import { React, useState, useEffect, useRef } from "react";
import { getDatabase, ref, set, push, get } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, listAll } from "firebase/storage"
import "../../components/style.css";
import { useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import "firebase/compat/storage";
import loadingspinner from '../../assets/images/loading2.gif'
import AlertMessage from "../../AlertMessage";
import { useNavigate } from 'react-router-dom';
import StudentsReport from "./StudentsReport";
import useEnterKey from "./useEnterKey ";
import firebase, { storage } from '../firebase'
import { app } from "../firebase";
import { deleteObject } from "firebase/storage";
import { remove } from "firebase/database";
import { FaEdit } from 'react-icons/fa';
import businessman from '../../assets/images/teacher_7162968.png';
import StatesDataMarathi from '../StatesDataMarathi.json'
import StatesDataEnglish from '../StatesDataEnglish.json'


const database = getDatabase(app);


function StudentRegister() {

  const navigate = useNavigate();
  const inputs = useRef([]);
  const loadedSerialNo = useRef(null);
  const skipDuplicateCheck = useRef(false);
  const { handleFocus } = useEnterKey(inputs.current);

  const [showPopup, setShowPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [fileName, setFileName] = useState("");
  const [savedDocuments, setSavedDocuments] = useState([]);
  const [viewFileURL, setViewFileURL] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const today = new Date().toISOString().split("T")[0];

  const [stdData, setStdData] = useState({
    bookno: "",
    studentId: "",
    registerNo: "",
    aparId: "",
    panId: "",
    educationalYear: "",
    ELGA: "",
    stdSurname: "",
    stdName: "",
    stdFather: "",
    stdMother: "",
    stdAdharNo: "",
    religion: "",
    caste: "",
    subCaste: "",
    category: "",
    nationality: "",
    motherTounge: "",
    dateOfAdmission: today,
    country: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    birthPlace: "",
    gender: "",
    NCCScout: "",
    dob: "",
    dobInWords: "",
    mobileNo: "",
    prevSchool: "",
    prevClass: "",
    admissionClass: "",
    currentClass: "",
    division: "",
    stdPhoto: "",
    isMinority: false,
    isActive: true,
    isHosteller: "",
    isRTE: '',
    isScolar: "",
    isCWSN: "",
    isBPL: "",
    bloodGroup: '',
    fOccupation: '',
    mOccupation: '',
    fMobile: '',
    mMobile: '',
    birthmark: '',
    famIncome: '',
    totalChildren: '',
    birthOrder: '',
    pAdhar: '',
    address: '',
    pincode: '',
    prevPercent: '',
    prevMarks: '',
    adharmobileNo: '',
    accHolderName: '',
    accNo: '',
    bankName: '',
    branchName: '',
    IFSC: '',
    stdemailId: '',
    prevLCDate: '',
    fEducation: '',
    mEducation: '',
    distance: '',
    disabilityName: '',
  });

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const udiseNumber = localStorage.getItem("udiseNumber");

  const [showPersonalDetails, setShowPersonalDetails] = useState(false);
  const [showAddressDetails, setShowAddressDetails] = useState(false);
  const [showPreviousSchoolDetails, setShowPreviousSchoolDetails] = useState(false);
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [showParentsInfo, setShowParentsInfo] = useState(false);
  const [showBankInfo, setShowBankInfo] = useState(false);

  const togglePersonalDetails = () => {
    setShowPersonalDetails(prev => !prev);
  };

  const toggleAddressDetails = () => {
    setShowAddressDetails(prev => !prev);
  };

  const togglePreviousSchoolDetails = () => {
    setShowPreviousSchoolDetails(prev => !prev);
  };

  const toggleOtherDetails = () => {
    setShowOtherDetails(prev => !prev);
  };

  const toggleParentsInfo = () => {
    setShowParentsInfo(prev => !prev);
  };

  const toggleBankInfo = () => {
    setShowBankInfo(prev => !prev);
  };


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  const [isEditingReligion, setIsEditingReligion] = useState(false);
  const [isEditingPrevSchool, setIsEditingPrevSchool] = useState(false);
  const [editReligionIndex, setEditReligionIndex] = useState(null);
  const [editPrevSchoolIndex, setEditPrevSchoolIndex] = useState(null);
  // const [isEditingCountry, setIsEditingCountry] = useState(false);
  // const [editCountryIndex, setEditCountryIndex] = useState(null);

  const [isEditingMotherTounge, setIsEditingMotherTounge] = useState(false);
  const [editMotherToungeIndex, setEditMotherToungeIndex] = useState(null);

  const [isEditingCaste, setIsEditingCaste] = useState(false);
  const [editCasteIndex, setEditCasteIndex] = useState(null);
  const [isEditingNationality, setIsEditingNationality] = useState(false);
  const [editNationalityIndex, setEditNationalityIndex] = useState(null);
  const [isEditingDivision, setIsEditingDivision] = useState(false);
  const [editDivisionIndex, setEditDivisionIndex] = useState(null);
  // const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [logoFile, setLogoFile] = useState(null);

  const [logoURL, setLogoURL] = useState(null);

  const language = localStorage.getItem('language') || "English";
  const [schoolName, setSchoolName] = useState(localStorage.getItem("schoolName") || "");

  const [showReport, setShowReport] = useState(false);
  const [selectedStudentData, setSelectedStudentData] = useState(null);

  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);


  useEffect(() => {
    fetchSchoolData()
  }, [udiseNumber]);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [bookno, setBookNumber] = useState("");
  const [bookNumbers, setBookNumbers] = useState([]);
  const [newBookNumber, setNewBookNumber] = useState("");
  const [showNewBookForm, setShowNewBookForm] = useState(false);

  const [classes, setClasses] = useState([]); // To hold class names
  const [divisions, setDivisions] = useState({}); // To hold divisions for each class

  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);

        const classList = [];
        const divisionList = {};

        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            // Class without divisions
            classList.push(className);
            divisionList[className] = []; // Initialize with an empty array
          } else if (typeof value === 'object') {
            // Class with divisions
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }

        setClasses(classList);
        setDivisions(divisionList); // Set the divisionList as the state
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };
  // const allDivisions = Object.values(divisions).flat();
  const allDivisions = Array.from(new Set(Object.values(divisions).flat()));
  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);


  const [religion, setReligion] = useState("");

  const [religions, setReligions] = useState([]);
  const [newReligion, setNewReligion] = useState("");
  const [showNewReligionForm, setShowNewReligionForm] = useState(false);

  const [prevSchool, setPrevSchool] = useState("");
  const [prevSchools, setPrevSchools] = useState([]);
  const [newPrevSchool, setNewPrevSchool] = useState("");
  const [showNewPrevSchoolForm, setShowNewPrevSchoolForm] = useState(false);

  const [isOpenPrevSchoolDropdown, setIsOpenPrevSchoolDropdown] = useState(false);
  const [searchPrevSchoolQuery, setSearchPrevSchoolQuery] = useState("");
  const prevSchoolDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (prevSchoolDropdownRef.current && !prevSchoolDropdownRef.current.contains(event.target)) {
        setIsOpenPrevSchoolDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredSchools = prevSchools.filter(school =>
    school.toLowerCase().includes(searchPrevSchoolQuery.toLowerCase())
  );

  const [division, setDivision] = useState("");
  const [newDivision, setNewDivision] = useState("");
  const [showNewDivisionForm, setShowNewDivisionForm] = useState(false);

  const [nationality, setNationality] = useState("");
  const [nationalities, setNationalities] = useState([]);
  const [newNationality, setNewNationality] = useState("");
  const [showNewNationalityForm, setShowNewNationalityForm] = useState(false);

  const [motherTounge, setMotherTounge] = useState("");
  const [motherTounges, setMotherTounges] = useState([]);
  const [newMotherTounge, setNewMotherTounge] = useState("");
  const [showNewMotherToungeForm, setShowNewMotherToungeForm] = useState(false);

  const [caste, setCaste] = useState("");
  const [castes, setCastes] = useState([]);
  const [newCaste, setNewCaste] = useState("");
  const [showNewCasteForm, setShowNewCasteForm] = useState(false);


  const [country, setCountry] = useState("");

  const [state, setState] = useState("");
  const [states, setStates] = useState([]);
  const [newState, setNewState] = useState("");
  // const [showNewStateForm, setShowNewStateForm] = useState(false);

  const [showCasteInput, setShowCasteInput] = useState(false);
  const [casteCategory, setCasteCategory] = useState("");
  const [isMinority, setIsMinority] = useState(false);
  const [isActive, setIsActive] = useState(true); // Default to true (active)

  const [isHosteller, setIsHosteller] = useState("");
  const [isRTE, setIsRTE] = useState("");
  const [isScolar, setIsScolar] = useState("");
  const [isCWSN, setIsCWSN] = useState("");
  const [isBPL, setIsBPL] = useState("");
  const [isAAY, setIsAAY] = useState("");


  const [educationalYear, setEducationalYear] = useState("");
  const [educationalYears, setEducationalYears] = useState([]);
  const [newEducationalYear, setNewEducationalYear] = useState("");
  const [showNewEducationalYearForm, setShowNewEducationalYearForm] = useState(false);

  const [ELGA, setELGA] = useState("");
  const [ELGAs, setELGAs] = useState([]);
  const [newELGA, setNewELGA] = useState("");
  const [showNewELGAForm, setShowNewELGAForm] = useState(false);

  const [admissionClass, setAdmissionClass] = useState("");
  const [admissionClasses, setAdmissionClasses] = useState([]);
  const [newAdmissionClass, setNewAdmissionClass] = useState("");
  const [showNewAdmissionClassForm, setShowNewAdmissionClassForm] = useState(false);

  const [currentClass, setCurrentClass] = useState("");
  const [currentClasses, setCurrentClasses] = useState([]);
  const [newCurrentClass, setNewCurrentClass] = useState("");
  const [showNewCurrentClassForm, setShowNewCurrentClassForm] = useState(false);

  const [gender, setGender] = useState("");
  const [NCCScout, setNCCScout] = useState("");

  const [registerNoExists, setRegisterNoExists] = useState(false);
  const [relatedData, setRelatedData] = useState(null);
  const location = useLocation();

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");

  useEffect(() => {
    const inputs = document.querySelectorAll('input:not([type="radio"]), select');
    inputs.forEach((input, index) => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && (input.value === '' || input.tagName === 'SELECT')) {
          if (index > 0) {
            inputs[index - 1].focus();
          }
        }
      });
    });
  }, []);

  useEffect(() => {
    fetchSchoolData()
  }, []);

  // Function to open IndexedDB and get student data
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);

        request.onerror = (event) => {
          event.preventDefault();
          console.error('Database error:', event.target.error);
          reject('Error opening IndexedDB');
        };

        request.onsuccess = (event) => {
          resolve(event.target.result);
        };

        // If the database doesn't exist yet, create it
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('studentData')) {
            db.createObjectStore('studentData', { keyPath: 'id' });
          }
        };
      } catch (err) {
        console.error('Synchronous error opening IndexedDB:', err);
        reject(err);
      }
    });
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const db = await openIndexedDB(); // Open the IndexedDB
        const transaction = db.transaction('studentData', 'readonly'); // Create a read-only transaction
        const objectStore = transaction.objectStore('studentData'); // Access the object store
        const request = objectStore.getAll(); // Get all records from the object store

        request.onsuccess = (event) => {
          const data = event.target.result; // Get the data from the event

          if (data && data.length > 0) {
            const validData = data.filter(item => item !== null); // Filter out null values

            const bookNumbers = extractUniqueValuesAsString(validData, 'bookno');
            const religions = extractUniqueValuesAsString(validData, 'religion');
            const prevSchools = extractUniqueValuesAsString(validData, 'prevSchool');
            const nationalities = extractUniqueValuesAsString(validData, 'nationality');
            const motherTounges = extractUniqueValuesAsString(validData, 'motherTounge');
            const castes = extractUniqueValuesAsString(validData, 'caste');
            const states = extractUniqueValuesAsString(validData, 'state');
            const educationalYears = extractUniqueValuesAsString(validData, 'educationalYear');
            const ELGAs = extractUniqueValuesAsString(validData, 'ELGA');


            setBookNumbers(bookNumbers);
            setReligions(religions);
            setPrevSchools(prevSchools);
            setNationalities(nationalities);
            setMotherTounges(motherTounges);
            setCastes(castes);
            setStates(states);
            setEducationalYears(educationalYears);
            setELGAs(ELGAs);
            // Fetch documents for each student
            const documents = validData.map(item => ({
              serialNo: item.serialNo,
              documents: item.documents || [] // Ensure documents are fetched
            }));
            if (stdData.serialNo) {
              const currentStd = validData.find(item => item && String(item.serialNo) === String(stdData.serialNo));
              if (currentStd && currentStd.documents) {
                const docs = Array.isArray(currentStd.documents) ? currentStd.documents : Object.values(currentStd.documents);
                setSavedDocuments(docs);
              }
            }

          }
        };

        request.onerror = (event) => {
          console.error("Error fetching data from :", event.target.error);
        };
      } catch (error) {
        console.error("Error opening :", error);
      }
    };

    const extractUniqueValuesAsString = (data, key) => {
      const values = data
        .map(item => item[key]?.toString() ?? "")
        .filter(value => value !== "");
      return [...new Set(values)];
    };

    fetchData();
  }, [udiseNumber]);

  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            if (data.schoolName) {
              setSchoolName(data.schoolName);
            }
            setStdData(prevData => ({
              ...prevData,
              district: data.jilha || "", // Set default district
              taluka: data.taluka || "", // Set default taluka
            }));
            setSelectedDistrict(data.jilha || ""); // Set selected district
            setSelectedTaluka(data.taluka || "");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const data = event.target.result;

          if (data) {
            setEducationalYear(data.defaultYear || "");
            setCurrentClass(data.defaultCurrentClass || ""); // Set the default current class
            setAdmissionClass(data.defaultAdmissionClass || ""); // Set the default current class
            setCountry(language === "English" ? "India" : "भारत");
            setNationality(language === "English" ? "Indian" : "भारतीय");
            setState(language === "English" ? "Maharashtra" : "महाराष्ट्र");
            setReligion(language === "English" ? "Hindu" : "हिंदू");
            handleStateChange({ target: { value: language === "English" ? "Maharashtra" : "महाराष्ट्र" } });

          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    }
    fetchDefaultSettings();
  }, [udiseNumber]);



  useEffect(() => {
    setStdData(prevData => ({
      ...prevData,
      bookno: bookno,
      admissionClass: admissionClass,
      currentClass: currentClass,
      religion: religion,
      prevSchool: prevSchool,
      division: division,
      nationality: nationality,
      motherTounge: motherTounge,
      caste: caste,
      state: state,
      educationalYear: educationalYear,
      ELGA: ELGA,
      gender: gender,
      NCCScout: NCCScout,
      isHosteller: isHosteller,
      isRTE: isRTE,
      isScolar: isScolar,
      isCWSN: isCWSN,
      isBPL: isBPL,
      isAAY: isAAY,
    }));
  }, [
    udiseNumber,
    bookno,
    admissionClass,
    currentClass,
    religion,
    prevSchool,
    division,
    nationality,
    motherTounge,
    caste,
    state,
    educationalYear,
    ELGA,
    gender,
    NCCScout,
    isHosteller,
    isRTE,
    isScolar,
    isCWSN,
    isAAY,
    isBPL,
  ]);

  const [progress, setProgress] = useState(100);

  const handleLogoChange = (e) => {

    const file = e.target.files[0];
    setLogoFile(file);

    if (file) {
      setSavingData(true);
      setProgress(0)
      if (savingData == true) {
        console.log("saving data is true");

      }
      const storageRef = firebase.storage().ref();
      const uploadTask = storageRef.child(`${udiseNumber}/student${stdData.serialNo}`).put(file);


      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          console.log("Upload is " + progress + "% done");
          setProgress(progress)
          setSavingData(false);
        },
        (error) => {
          console.error("Error uploading logo:", error);
          setAlertMessage("Failed to upload logo");
          setSavingData(false);
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLogoURL(downloadURL); // Set the logo URL for preview
            setStdData((prevData) => ({
              ...prevData,
              stdPhoto: downloadURL, // Update stdData with the new photo URL
            }));
          });
        }
      );
    } else {
      setLogoURL('');
    }
  };



  const handleBookNumChange = (event) => {
    if (language === 'Marathi' && event.key === 'Tab') {
      const nextInputField = document.querySelector('input[name="registerNo"]');
      nextInputField.focus();
    }
    const selectedValue = event.target.value;
    if (selectedValue === "addNewBook") {
      setShowNewBookForm(true);
    } else {
      setBookNumber(selectedValue);  // Set the book number state
      setShowNewBookForm(false);

      // Update the stdData object with the new book number
      setStdData(prevData => ({
        ...prevData,
        bookno: selectedValue
      }));
    }
  };

  const handleNewBookSubmit = () => {
    if (newBookNumber.trim() !== "") {
      setBookNumbers(prevBookNumbers => [...prevBookNumbers, newBookNumber]);
      setBookNumber(newBookNumber);
      setShowNewBookForm(false);
    }
  };

  const handleAdmissionClassChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewAdmissionClass") {
      setShowNewAdmissionClassForm(true);
    } else {
      setAdmissionClass(selectedValue);
      setSelectedClass(selectedValue)
      setCurrentClass(selectedValue);
      setShowNewAdmissionClassForm(false);
      setAdmissionClasses((prevClasses) => [...prevClasses, selectedValue]);
    }
  };

  const handleNewAdmissionClassSubmit = () => {
    if (newAdmissionClass.trim() !== "") {
      setSelectedClass(newAdmissionClass)
      setAdmissionClasses((prevClasses) => [...prevClasses, newAdmissionClass]);
      setAdmissionClass(newAdmissionClass);
      setShowNewAdmissionClassForm(false);
      setClasses((prevClasses) => [...prevClasses, newAdmissionClass]);
    }
  };

  const handleCurrentClassChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewCurrentClass") {
      setShowNewCurrentClassForm(true);
    } else {
      setCurrentClass(selectedValue);
      setSelectedClass(selectedValue)
      setShowNewCurrentClassForm(false);
      setCurrentClasses((prevClasses) => [...prevClasses, selectedValue]);
    }
  };

  const handleNewCurrentClassSubmit = () => {
    if (newCurrentClass.trim() !== "") {
      setSelectedClass(newCurrentClass)
      setCurrentClasses([...currentClasses, newCurrentClass]);
      setCurrentClass(newCurrentClass);
      setClasses((prevClasses) => [...prevClasses, newCurrentClass]);
      setShowNewCurrentClassForm(false);
    }
  };

  const handleReligionChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewRel") {
      setShowNewReligionForm(true);
    } else {
      setReligion(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        religion: selectedValue
      }));
      setShowNewReligionForm(false);
    }
  };
  const handleNewReligionSubmit = () => {
    if (newReligion.trim() !== "") {
      if (isEditingReligion) {
        const updatedReligions = religions.map((religion, index) =>
          index === editReligionIndex ? newReligion : religion
        );
        setReligions(updatedReligions);
        setIsEditingReligion(false);
        setEditReligionIndex(null);
      } else {
        setReligions([...religions, newReligion]);
      }
      setNewReligion('');
      setShowNewReligionForm(false);
    }
  };

  const handlePrevSchoolChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewPrevSchool") {
      setShowNewPrevSchoolForm(true);
    } else {
      setPrevSchool(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        prevSchool: selectedValue
      }));
      setShowNewPrevSchoolForm(false);
    }
  };
  const handleNewPrevSchoolSubmit = () => {
    if (newPrevSchool.trim() !== "") {
      if (isEditingPrevSchool) {
        const updatedSchools = prevSchools.map((school, index) =>
          index === editPrevSchoolIndex ? newPrevSchool : school
        );
        setPrevSchools(updatedSchools);
        setIsEditingPrevSchool(false);
        setEditPrevSchoolIndex(null);
      } else {
        setPrevSchools([...prevSchools, newPrevSchool]);
      }
      setNewPrevSchool('');
      setShowNewPrevSchoolForm(false);
    }
  };

  const handleDivisionChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewDivision") {
      setShowNewDivisionForm(true);
    } else {
      setDivision(selectedValue);
      setShowNewDivisionForm(false);
      // Update the divisions for the selected class
      setDivisions((prevDivs) => {
        const updatedDivs = { ...prevDivs };
        if (!updatedDivs[selectedClass]) {
          updatedDivs[selectedClass] = []; // Initialize if it doesn't exist
        }
        updatedDivs[selectedClass].push(selectedValue); // Add the new division
        return updatedDivs;
      });
    }
  };


  const handleNewDivisionSubmit = (e) => {
    e.preventDefault();

    const classname = selectedClass || currentClass;
    if (newDivision !== "" && classname) {
      if (!divisions[classname]) {
        divisions[classname] = [];
      }

      if (!divisions[classname].includes(newDivision)) {
        setDivisions((prevDivisions) => ({
          ...prevDivisions,
          [classname]: [...prevDivisions[classname], newDivision],
        }));
      }

      setNewDivision('');
      setShowNewDivisionForm(false);
    }
  };



  const handleMotherToungeChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewMotherTounge") {
      setShowNewMotherToungeForm(true);
    } else {
      setMotherTounge(selectedValue);
      setShowNewMotherToungeForm(false);
    }
  };
  const handleNewMotherToungeSubmit = () => {
    if (newMotherTounge.trim() !== "") {
      if (isEditingMotherTounge) {
        const updatedMotherTounges = motherTounges.map((motherTounge, index) =>
          index === editMotherToungeIndex ? newMotherTounge : motherTounge
        );
        setMotherTounges(updatedMotherTounges);
        setIsEditingMotherTounge(false);
        setEditMotherToungeIndex(null);
      } else {
        setMotherTounges([...motherTounges, newMotherTounge]);
      }
      setNewMotherTounge('');
      setShowNewMotherToungeForm(false);
    }
  };

  const handleCasteChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewCaste") {
      setShowNewCasteForm(true);
    } else {
      setCaste(selectedValue);
      setShowNewCasteForm(false);
    }
  };
  const handleNewCasteSubmit = () => {
    if (newCaste.trim() !== "") {
      if (isEditingCaste) {
        const updatedCastes = castes.map((caste, index) =>
          index === editCasteIndex ? newCaste : caste
        );
        setCastes(updatedCastes);
        setIsEditingCaste(false);
        setEditCasteIndex(null);
      } else {
        setCastes([...castes, newCaste]);
      }
      setNewCaste('');
      setShowNewCasteForm(false);
    }
  };

  const handleNationalityChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewNat") {
      setShowNewNationalityForm(true);
    } else {
      setNationality(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        nationality: selectedValue
      }));
      setShowNewNationalityForm(false);
    }
  };
  const handleNewNationalitySubmit = () => {
    if (newNationality.trim() !== "") {
      if (isEditingNationality) {
        const updatedNationalities = nationalities.map((nationality, index) =>
          index === editNationalityIndex ? newNationality : nationality
        );
        setNationalities(updatedNationalities);
        setIsEditingNationality(false);
        setEditNationalityIndex(null);
      } else {
        setNationalities([...nationalities, newNationality]);
      }
      setNewNationality('');
      setShowNewNationalityForm(false);
    }
  };

  const handleCountryChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewCountry") {
      // setShowNewCountryForm(true);
    } else {
      setCountry(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        country: selectedValue
      }));
      // setShowNewCountryForm(false);
    }
  };

  // const handleStateChange = (event) => {
  //   const selectedValue = event.target.value;
  //   if (selectedValue === "addNewState") {
  //     setShowNewStateForm(true);
  //   } else {
  //     setState(selectedValue);
  //     setStdData(prevData => ({
  //       ...prevData,
  //       state: selectedValue 
  //     }));
  //     setShowNewStateForm(false);
  //   }
  // };

  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    setState(selectedState);

    // Fetch districts and talukas from the appropriate JSON data
    const statesData = language === 'Marathi' ? StatesDataMarathi : StatesDataEnglish;

    if (statesData[selectedState]) {
      setDistricts(statesData[selectedState].districts);
      setTalukas(statesData[selectedState].talukas);
    } else {
      setDistricts([]);
      setTalukas({});
    }
  };


  const handleNewStateSubmit = () => {
    if (newState.trim() !== "") {
      setStates([...states, newState]);
      setState(newState);
      // setShowNewStateForm(false);
    }
  };

  const handleEduYearChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewEducationalYear") {
      setShowNewEducationalYearForm(true);
    } else {
      setEducationalYear(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        educationalYear: selectedValue
      }));
      setShowNewEducationalYearForm(false);
    }
  };

  const handleNewEducationalYearSubmit = () => {
    if (newEducationalYear.trim() !== "") {
      setEducationalYears([...educationalYears, newEducationalYear]);
      setEducationalYear(newEducationalYear);
      setShowNewEducationalYearForm(false);
    }
  };

  const handleELGAChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "addNewELGA") {
      setShowNewELGAForm(true);
    } else {
      setELGA(selectedValue);
      setStdData(prevData => ({
        ...prevData,
        ELGA: selectedValue
      }));
      setShowNewELGAForm(false);
    }
  };

  const handleNewELGASubmit = () => {
    if (newELGA.trim() !== "") {
      setELGAs([...ELGAs, newELGA]);
      setELGA(newELGA);
      setShowNewELGAForm(false);
    }
  };
  const handleDistrictChange = (event) => {
    const district = event.target.value;
    setSelectedDistrict(district);
    setSelectedTaluka("");
    setStdData(prevData => ({
      ...prevData,
      district: district,
      taluka: "",
    }));
  };

  const handleTalukaChange = (event) => {
    const taluka = event.target.value;
    setSelectedTaluka(taluka);

    setStdData(prevData => ({
      ...prevData,
      taluka: taluka,
    }));
  };



  const handleCategoryChange = (event) => {
    setCasteCategory(event.target.value);
    setStdData((prevData) => ({
      ...prevData,
      casteCategory: event.target.value,
    }));
  };

  const handleMinorityChange = (event) => {
    setIsMinority(event.target.checked);
    setStdData((prevData) => ({
      ...prevData,
      isMinority: event.target.checked,
    }));
  };

  const handleStdStatusChange = (event) => {
    const isChecked = event.target.checked; // Get the checked status
    setIsActive(isChecked); // Update the local state
    setStdData(prevData => ({
      ...prevData,
      isActive: isChecked, // Update the stdData with the new isActive value
    }));
  };


  const handleHostellerChange = (event) => {
    setIsHosteller(event.target.value);
  };

  const handleScolarChange = (event) => {
    setIsScolar(event.target.value);
    if (event.target.value === "true") {
      setStdData((prevData) => ({
        ...prevData,
        isScolar: true,
        scolarName: "", // Initialize scolarName as an empty string
      }));
    } else {
      setStdData((prevData) => ({
        ...prevData,
        isScolar: false,
        scolarName: "", // Reset scolarName to an empty string
      }));
    }
  };

  const handleCWSNChange = (event) => {
    setIsCWSN(event.target.value);
    if (event.target.value === "true") {
      setStdData((prevData) => ({
        ...prevData,
        isCWSN: true,
        disabilityName: "",
      }));
    } else {
      setStdData((prevData) => ({
        ...prevData,
        isCWSN: false,
        disabilityName: "",
      }));
    }
  };


  const handleRTEChange = (event) => {
    setIsRTE(event.target.value);
  }
  const handleBPLChange = (event) => {
    setIsBPL(event.target.value);
  }

  const handleAAYChange = (event) => {
    setIsAAY(event.target.value);
  }


  const [showMinorityForm, setShowMinorityForm] = useState(false);

  const handleShowMinorityForm = (e) => {
    e.preventDefault();
    setShowMinorityForm(true);
  };

  const handleCloseMinorityForm = () => {
    setShowMinorityForm(false);
  };

  const handleTextChange = (event) => {
    const { name, value } = event.target;

    if (name === "registerNo") {
      skipDuplicateCheck.current = false;
    }

    let updatedData = { ...stdData };

    updatedData[name] = value;

    if (name === "mobileNo" || name === "fMobile" || name === "mMobile" || name === 'adharmobileNo') {
      const numericValue = value.replace(/\D/g, "");
      const formattedValue = numericValue.slice(0, 10);
      updatedData[name] = formattedValue;
    }
    if (name === "pincode") {
      const numericValue = value.replace(/\D/g, "");
      const formattedValue = numericValue.slice(0, 6);
      updatedData[name] = formattedValue;
    }

    if (name === "stdAdharNo" | name === "pAdhar") {
      const numericValue = value.replace(/\D/g, "");

      const formattedValue = numericValue
        .slice(0, 12)
        .replace(/(.{4})/g, "$1 ")
        .trim();
      updatedData[name] = formattedValue;
    }
    // console.log("updatedData",updatedData);

    setStdData(updatedData);
  };

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleNCCScoutChange = (event) => {
    setNCCScout(event.target.value);
  };

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  function convertDateToWords(date) {
    const dateObj = new Date(date);
    const dayValue = [
      { 1: "First" }, { 2: "Second" }, { 3: "Third" }, { 4: "Fourth" }, { 5: "Fifth" }, { 6: "Sixth" },
      { 7: "Seventh" }, { 8: "Eighth" }, { 9: "Ninth" }, { 10: "Tenth" }, { 11: "Eleventh" }, { 12: "Twelfth" },
      { 13: "Thirteenth" }, { 14: "Fourteenth" }, { 15: "Fifteenth" }, { 16: "Sixteenth" }, { 17: "Seventeenth" },
      { 18: "Eighteenth" }, { 19: "Nineteenth" }, { 20: "Twentieth" }, { 21: "Twenty-First" }, { 22: "Twenty-Second" },
      { 23: "Twenty-Third" }, { 24: "Twenty-Fourth" }, { 25: "Twenty-Fifth" }, { 26: "Twenty-Sixth" },
      { 27: "Twenty-Seventh" }, { 28: "Twenty-Eighth" }, { 29: "Twenty-Ninth" }, { 30: "Thirtieth" },
      { 31: "Thirty-First" }
    ];
    const dayValueInMarathi = [
      { 1: "एक" }, { 2: "दोन" }, { 3: "तीन" }, { 4: "चार" }, { 5: "पाच" }, { 6: "सहा" },
      { 7: "सात" }, { 8: "आठ" }, { 9: "नऊ	" }, { 10: "दहा" }, { 11: "अकरा" }, { 12: "बारा" },
      { 13: "तेरा" }, { 14: "चौदा" }, { 15: "पंधरा" }, { 16: "सोळा" }, { 17: "सतरा" },
      { 18: "अठरा" }, { 19: "एकोणीस" }, { 20: "वीस" }, { 21: "एकवीस" }, { 22: "बावीस" },
      { 23: "तेवीस" }, { 24: "चोवीस" }, { 25: "पंचवीस" }, { 26: "सव्वीस" },
      { 27: "सत्तावीस" }, { 28: "अठ्ठावीस" }, { 29: "एकोणतीस" }, { 30: "तीस" },
      { 31: "एकतीस" }
    ];
    const monthNames = {
      1: "January", 2: "February", 3: "March", 4: "April", 5: "May", 6: "June",
      7: "July", 8: "August", 9: "September", 10: "October", 11: "November", 12: "December"
    };
    const monthNamesInMarathi = {
      1: "जानेवारी", 2: "फेब्रुवारी", 3: "मार्च", 4: "एप्रिल", 5: "मे", 6: "जून",
      7: "जुलै", 8: "ऑगस्ट", 9: "सप्टेंबर", 10: "ऑक्टोबर", 11: "नोव्हेंबर", 12: "डिसेंबर"
    };

    const yearValue = {
      1970: "nineteen seventy", 1971: "nineteen seventy one", 1972: "nineteen seventy two", 1973: "nineteen seventy three", 1974: "nineteen seventy four", 1975: "nineteen seventy five", 1976: "nineteen seventy six", 1977: "nineteen seventy seven", 1978: "nineteen seventy eight", 1979: "nineteen seventy nine", 1980: "nineteen eighty", 1981: "nineteen eighty one", 1982: "nineteen eighty two", 1983: "nineteen eighty three", 1984: "nineteen eighty four", 1985: "nineteen eighty five", 1986: "nineteen eighty six", 1987: "nineteen eighty seven", 1988: "nineteen eighty eight", 1989: "nineteen eighty nine", 1990: "nineteen ninety",
      1990: "nineteen ninety", 1991: "nineteen ninety one", 1992: "nineteen ninety two", 1993: "nineteen ninety three",
      1994: "nineteen ninety four", 1995: "nineteen ninety five", 1996: "nineteen ninety six", 1997: "nineteen ninety seven",
      1998: "nineteen ninety eight", 1999: "nineteen ninety nine", 2000: "two thousand", 2001: "two thousand one",
      2002: "two thousand two", 2003: "two thousand three", 2004: "two thousand four", 2005: "two thousand five",
      2006: "two thousand six", 2007: "two thousand seven", 2008: "two thousand eight", 2009: "two thousand nine",
      2010: "two thousand ten", 2011: "two thousand eleven", 2012: "two thousand twelve", 2013: "two thousand thirteen",
      2014: "two thousand fourteen", 2015: "two thousand fifteen", 2016: "two thousand sixteen", 2017: "two thousand seventeen",
      2018: "two thousand eighteen", 2019: "two thousand nineteen", 2020: "two thousand twenty", 2021: "two thousand twenty one",
      2022: "two thousand twenty two", 2023: "two thousand twenty three", 2024: "two thousand twenty four", 2025: "two thousand twenty five",
      2026: "two thousand twenty six", 2027: "two thousand twenty seven", 2028: "two thousand twenty eight", 2029: "two thousand twenty nine",
      2030: "two thousand thirty", 2031: "two thousand thirty one", 2032: "two thousand thirty two", 2033: "two thousand thirty three",
      2034: "two thousand thirty four", 2035: "two thousand thirty five", 2036: "two thousand thirty six", 2037: "two thousand thirty seven",
      2038: "two thousand thirty eight", 2039: "two thousand thirty nine", 2040: "two thousand forty", 2041: "two thousand forty one",
      2042: "two thousand forty two", 2043: "two thousand forty three", 2044: "two thousand forty four", 2045: "two thousand forty five",
      2046: "two thousand forty six", 2047: "two thousand forty seven", 2048: "two thousand forty eight", 2049: "two thousand forty nine",
      2050: "two thousand fifty", 2051: "two thousand fifty one", 2052: "two thousand fifty two", 2053: "two thousand fifty three",
      2054: "two thousand fifty four", 2055: "two thousand fifty five", 2056: "two thousand fifty six", 2057: "two thousand fifty seven",
      2058: "two thousand fifty eight", 2059: "two thousand fifty nine", 2060: "two thousand sixty", 2061: "two thousand sixty one",
      2062: "two thousand sixty two", 2063: "two thousand sixty three", 2064: "two thousand sixty four", 2065: "two thousand sixty five",
      2066: "two thousand sixty six", 2067: "two thousand sixty seven", 2068: "two thousand sixty eight", 2069: "two thousand sixty nine",
      2070: "two thousand seventy", 2071: "two thousand seventy one", 2072: "two thousand seventy two", 2073: "two thousand seventy three",
      2074: "two thousand seventy four", 2075: "two thousand seventy five", 2076: "two thousand seventy six", 2077: "two thousand seventy seven",
      2078: "two thousand seventy eight", 2079: "two thousand seventy nine", 2080: "two thousand eighty", 2081: "two thousand eighty one",
      2082: "two thousand eighty two", 2083: "two thousand eighty three", 2084: "two thousand eighty four", 2085: "two thousand eighty five",
      2086: "two thousand eighty six", 2087: "two thousand eighty seven", 2088: "two thousand eighty eight", 2089: "two thousand eighty nine",
      2090: "two thousand ninety", 2091: "two thousand ninety one", 2092: "two thousand ninety two", 2093: "two thousand ninety three",
      2094: "two thousand ninety four", 2095: "two thousand ninety five", 2096: "two thousand ninety six", 2097: "two thousand ninety seven",
      2098: "two thousand ninety eight", 2099: "two thousand ninety nine", 2100: "two thousand one hundred"
    };

    const yearValueInMarathi = {
      1970: "एकोणीशे सत्तर", 1971: "एकोणीशे एक्काहत्तर", 1972: "एकोणीशे बाहत्तर", 1973: "एकोणीशे त्र्याहत्तर", 1974: "एकोणीशे चौर्याहत्तर", 1975: "एकोणीशे पंच्याहत्तर", 1976: "एकोणीशे शहात्तर", 1977: "एकोणीशे सत्याहत्तर", 1978: "एकोणीशे अठ्ठ्याहत्तर", 1979: "एकोणीशे एकोणऐंशी", 1980: "एकोणीशे ऐंशी", 1981: "एकोणीशे एक्क्याऐंशी", 1982: "एकोणीशे ब्याऐंशी",
      1983: "एकोणीशे त्र्याऐंशी", 1984: "एकोणीशे चौर्याऐंशी", 1985: "एकोणीशे पंच्याऐंशी", 1986: "एकोणीशे शहाऐंशी", 1987: "एकोणीशे सत्त्याऐंशी", 1988: "एकोणीशे अठ्ठ्याऐंशी", 1989: "एकोणीशे एकोणनव्वद", 1990: "एकोणीशे नव्वद", 1991: "एकोणीशे एक्यान्नव", 1992: "एकोणीशे ब्यान्नव", 1993: "एकोणीशे त्र्यान्नव", 1994: "एकोणीशे चौर्यान्नव", 1995: "एकोणीशे पंच्यान्नव", 1996: "एकोणीशे शहान्नव", 1997: "एकोणीशे सत्त्यान्नव", 1998: "एकोणीशे अठ्यान्नव", 1999: "एकोणीशे नव्यान्नव", 2000: "दोन हजार",
      2001: "दोन हजार एक", 2002: "दोन हजार दोन", 2003: "दोन हजार तीन", 2004: "दोन हजार चार", 2005: "दोन हजार पाच", 2006: "दोन हजार सहा", 2007: "दोन हजार सात", 2008: "दोन हजार आठ", 2009: "दोन हजार नऊ", 2010: "दोन हजार दहा",
      2011: "दोन हजार अकरा", 2012: "दोन हजार बारा", 2013: "दोन हजार तेरा", 2014: "दोन हजार चौदा", 2015: "दोन हजार पंधरा", 2016: "दोन हजार सोळा", 2017: "दोन हजार सतरा", 2018: "दोन हजार अठरा", 2019: "दोन हजार एकोणीस",
      2020: "दोन हजार वीस", 2021: "दोन हजार एकवीस", 2022: "दोन हजार बावीस", 2023: "दोन हजार तेवीस", 2024: "दोन हजार चोवीस", 2025: "दोन हजार पंचवीस", 2026: "दोन हजार सव्वीस", 2027: "दोन हजार सत्तावीस", 2028: "दोन हजार अठ्ठावीस",
      2029: "दोन हजार एकोणतीस", 2030: "दोन हजार तीस", 2031: "दोन हजार एकतीस", 2032: "दोन हजार बत्तीस", 2033: "दोन हजार तेहतीस", 2034: "दोन हजार चौतीस", 2035: "दोन हजार पस्तीस", 2036: "दोन हजार छत्तीस", 2037: "दोन हजार सदतीस",
      2038: "दोन हजार अडतीस", 2039: "दोन हजार एकोणचाळीस", 2040: "दोन हजार चाळीस", 2041: "दोन हजार एक्केचाळीस", 2042: "दोन हजार बेचाळीस", 2043: "दोन हजार त्रेचाळीस", 2044: "दोन हजार चव्वेचाळीस", 2045: "दोन हजार पंचेचाळीस",
      2046: "दोन हजार सेहेचाळीस", 2047: "दोन हजार सत्तेचाळीस", 2048: "दोन हजार अठ्ठेचाळीस", 2049: "दोन हजार एकोणपन्नास", 2050: "दोन हजार पन्नास", 2051: "दोन हजार एक्कावन्न", 2052: "दोन हजार बावन्न", 2053: "दोन हजार त्रेपन्न",
      2054: "दोन हजार चोपन्न", 2055: "दोन हजार पंचावन्न", 2056: "दोन हजार छप्पन्न", 2057: "दोन हजार सत्तावन्न", 2058: "दोन हजार अठ्ठावन्न", 2059: "दोन हजार एकोणसाठ", 2060: "दोन हजार साठ", 2061: "दोन हजार एकसष्ठ", 2062: "दोन हजार बासष्ठ",
      2063: "दोन हजार त्रेसष्ठ", 2064: "दोन हजार चौसष्ठ", 2065: "दोन हजार पासष्ठ", 2066: "दोन हजार सहासष्ठ", 2067: "दोन हजार सदुसष्ठ", 2068: "दोन हजार अडुसष्ठ", 2069: "दोन हजार एकोणसत्तर", 2070: "दोन हजार सत्तर", 2071: "दोन हजार एक्काहत्तर",
      2072: "दोन हजार बाहत्तर", 2073: "दोन हजार त्र्याहत्तर", 2074: "दोन हजार चौर्‍याहत्तर", 2075: "दोन हजार पंच्याहत्तर", 2076: "दोन हजार शहात्तर", 2077: "दोन हजार सत्याहत्तर", 2078: "दोन हजार अठ्ठ्याहत्तर", 2079: "दोन हजार एकोण ऐंशी",
      2080: "दोन हजार ऐंशी", 2081: "दोन हजार एक्याऐंशी", 2082: "दोन हजार ब्याऐंशी", 2083: "दोन हजार त्र्याऐंशी", 2084: "दोन हजार चौऱ्याऐंशी", 2085: "दोन हजार पंच्याऐंशी", 2086: "दोन हजार शहाऐंशी", 2087: "दोन हजार सत्याऐंशी", 2088: "दोन हजार अठ्याऐंशी", 2089: "दोन हजार एकोणनव्वद", 2090: "दोन हजार नव्वद", 2091: "दोन हजार एक्याण्णव", 2092: "दोन हजार ब्याण्णव", 2093: "दोन हजार त्र्याण्णव", 2094: "दोन हजार चौऱ्याण्णव", 2095: "दोन हजार पंच्याण्णव", 2096: "दोन हजार शहाण्णव", 2097: "दोन हजार सत्त्याण्णव", 2098: "दोन हजार अठ्याण्णव", 2099: "दोन हजार नव्याण्णव", 2100: "एकवीसशे"
    };


    if (language === 'Marathi') {
      const day = dateObj.getDate().toString();
      const dayWord = dayValueInMarathi.find(obj => obj[day])[day];
      const monthIndex = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear().toString();
      if (year < 1970 || year > 2100) {
        return "तारीख उपलब्ध नाही";
      }
      const monthName = monthNamesInMarathi[monthIndex];
      const yearWords = yearValueInMarathi[year];

      return `${dayWord} ${monthName} ${yearWords}`;
    } else {
      const day = dateObj.getDate().toString();
      const dayWord = dayValue.find(obj => obj[day])[day];
      const monthIndex = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear().toString();
      if (year < 1970 || year > 2100) {
        return "Date is not available";
      }
      const monthName = monthNames[monthIndex];
      const yearWords = yearValue[year];

      return `${dayWord} ${monthName} ${yearWords}`;
    }
  }

  const handleDOBChange = (event) => {
    const dob = event.target.value;
    if (!dob) {
      setStdData({ ...stdData, dob: '', dobInWords: '' });
      return;
    }
    const dobInWords = convertDateToWords(dob);
    setStdData({ ...stdData, dob, dobInWords });
  };


  const handleprevLCDateChange = (event) => {
    const prevLCDate = event.target.value;
    if (!prevLCDate) {
      setStdData({ ...stdData, prevLCDate: '' });
      return;
    }
    setStdData({ ...stdData, prevLCDate });
  };


  const params = new URLSearchParams(location.search);
  const serialNumberFromUrl = params.get("serialNo");
  const [matchingRecords, setMatchingRecords] = useState([]);
  const [showMatchingRecords, setShowMatchingRecords] = useState(true);

  const updateFieldsAndState = (data) => {
    skipDuplicateCheck.current = true;
    try {
      if (data) {
        setGender(data.gender);
        setNCCScout(data.NCCScout);
        setIsHosteller(data.isHosteller);
        setIsRTE(data.isRTE);
        setIsScolar(data.isScolar);
        setIsBPL(data.isBPL);
        setIsCWSN(data.isCWSN);
        setIsAAY(data.isAAY);
        setAdmissionClass(data.admissionClass);
        setCurrentClass(data.currentClass);
        setReligion(data.religion);
        setPrevSchool(data.prevSchool);
        setDivision(data.division);
        setNationality(data.nationality);
        setMotherTounge(data.motherTounge);
        setCaste(data.caste);
        setCountry(data.country);
        setState(data.state);
        setEducationalYear(data.educationalYear);
        setELGA(data.ELGA);
        setSelectedDistrict(data.district);
        setSelectedTaluka(data.taluka);
        setBookNumber(data.bookno);
        setIsMinority(data.isMinority);
        setIsActive(data.isActive);
        setCasteCategory(data.casteCategory);

        setLogoURL(data.stdPhoto)

        const getSerialFromStudent = (s) => {
          if (!s) return '';
          if (s.serialNo) return String(s.serialNo);
          if (s.id) {
            const parts = s.id.split('-');
            return parts[parts.length - 1];
          }
          return '';
        };

        const currentSerial = getSerialFromStudent(data) || serialNumberFromUrl || localStorage.getItem('selectedStudentSerialNo');

        setStdData((prevData) => ({
          ...prevData,
          ...data,
          serialNo: currentSerial,
        }));
      }
    } catch (error) {
      console.error("Error updating fields and state: ", error);
    }
  };

  const handleRecordSelection = (record) => {
    if (record) {
      setRelatedData(record);
      updateFieldsAndState(record);
      setShowMatchingRecords(false);
      setSelectedStudentData(record);
      setoldDiv(record.division || ''); // Set oldDiv based on the selected record
      setoldCurClass(record.currentClass || '');
      if (serialNumberFromUrl) {
        loadedSerialNo.current = serialNumberFromUrl;
      }
    } else {
      setRelatedData(null);
      setShowMatchingRecords(false);
    }
  };

  const [olddiv, setoldDiv] = useState('')
  const [oldCurClass, setoldCurClass] = useState('')

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    const checkRegisterNoExists = async () => {
      try {
        const db = await openIndexedDB(); // Open the IndexedDB
        const transaction = db.transaction('studentData', 'readonly'); // Create a read-only transaction
        const objectStore = transaction.objectStore('studentData'); // Access the object store

        const getSerialFromStudent = (s) => {
          if (!s) return '';
          if (s.serialNo) return String(s.serialNo);
          if (s.id) {
            const parts = s.id.split('-');
            return parts[parts.length - 1];
          }
          return '';
        };

        if (serialNumberFromUrl && loadedSerialNo.current !== serialNumberFromUrl) {

          const request = objectStore.getAll(); // Get all records from the object store

          request.onsuccess = (event) => {
            const studentData = event.target.result; // Get all student data

            // Filter out null/undefined records, then find the matching record safely
            const validStudentData = Array.isArray(studentData)
              ? studentData.filter(data => data !== null && data !== undefined)
              : [];

            const matchingRecord = validStudentData.find(data => {
              if (!data) return false;
              const serial = getSerialFromStudent(data);
              return serial === serialNumberFromUrl;
            });

            if (matchingRecord) {
              setoldDiv(matchingRecord.division || '');
              setoldCurClass(matchingRecord.currentClass || '');
              updateFieldsAndState(matchingRecord); // Update the fields and state with the fetched data
              setRegisterNoExists(true);
              setSelectedStudentData(matchingRecord);
              setShowMatchingRecords(false);
              loadedSerialNo.current = serialNumberFromUrl;

              if (matchingRecord.state) {
                handleStateChange({ target: { value: matchingRecord.state } });
              }

            } else {
              console.log("No record found in IndexedDB. Fetching from Firebase via SDK...");
              const studentRef = ref(database, `schoolRegister/${udiseNumber}/studentData/${serialNumberFromUrl}`);
              get(studentRef).then((snapshot) => {
                if (snapshot.exists()) {
                  const data = snapshot.val();
                  console.log("Record found in Firebase via SDK:", data);
                  setoldDiv(data.division || '');
                  setoldCurClass(data.currentClass || '');
                  updateFieldsAndState(data);
                  setRegisterNoExists(!!data.registerNo);
                  setSelectedStudentData(data);
                  setShowMatchingRecords(false);
                  loadedSerialNo.current = serialNumberFromUrl;

                  // Also run handleStateChange so district/taluka lists populate if state exists
                  if (data.state) {
                    handleStateChange({ target: { value: data.state } });
                  }

                  // Cache to IndexedDB so subsequent lookups are local and instantaneous
                  openIndexedDB().then(db => {
                    const transaction = db.transaction('studentData', 'readwrite');
                    const objectStore = transaction.objectStore('studentData');
                    const key = `${data.currentClass || ''}-${data.division || ''}-${serialNumberFromUrl}`;
                    objectStore.put({ ...data, id: key, serialNo: Number(serialNumberFromUrl) });
                  });
                } else {
                  console.log("No record found in Firebase via SDK either.");
                }
              }).catch(err => {
                console.error("Error fetching from Firebase via SDK:", err);
              });
            }
          };

          request.onerror = (event) => {
            console.error("Error fetching data:", event.target.error);
          };
        }

        if (stdData.registerNo) {
          if (skipDuplicateCheck.current) {
            console.log("Skipping duplicate check for programmatic load or modal close");
            skipDuplicateCheck.current = false;
            setShowMatchingRecords(false);
            return;
          }
          const { registerNo } = stdData;
          const request = objectStore.getAll(); // Get all records from the object store

          request.onsuccess = (event) => {
            const studentData = event.target.result;

            // Filter out null values
            const validStudentData = studentData.filter(data => data !== null);

            // Filter matching records
            const currentSerialNoStr = (serialNumberFromUrl || stdData.serialNo || "").toString();
            const matchingRecords = validStudentData.filter(data => {
              if (!data || !data.registerNo) return false;
              const dataReg = String(data.registerNo).trim();
              const targetReg = String(registerNo).trim();
              if (dataReg !== targetReg) return false;

              const studentSerial = getSerialFromStudent(data);
              return !currentSerialNoStr || studentSerial !== currentSerialNoStr;
            });

            if (matchingRecords.length >= 1) {
              console.log("Matching records found:", matchingRecords);
              setMatchingRecords(matchingRecords);
              setRegisterNoExists(true);
              setShowMatchingRecords(true);
            } else {
              console.log("No matching record found.");
              setRelatedData(null); // Clear related data
              setShowMatchingRecords(false); // Hide matching records UI
              setRegisterNoExists(false);
            }
          };

          request.onerror = (event) => {
            console.error("Error fetching data:", event.target.error);
          };
        }
      } catch (error) {
        console.error("Error checking register number: ", error);
      }
    };
    checkRegisterNoExists();
    return () => {
      abortController.abort(); // Cancel ongoing fetch requests
    };
  }, [stdData.registerNo, stdData.serialNo, udiseNumber, serialNumberFromUrl]);

  const handleUpdate = async () => {
    try {
      let serialNoToUse = stdData.serialNo || serialNumberFromUrl || localStorage.getItem('selectedStudentSerialNo');

      if (!serialNoToUse && stdData.registerNo) {
        const getSerialFromStudent = (s) => {
          if (!s) return '';
          if (s.serialNo) return String(s.serialNo);
          if (s.id) {
            const parts = s.id.split('-');
            return parts[parts.length - 1];
          }
          return '';
        };

        let matched = null;
        if (matchingRecords && matchingRecords.length > 0) {
          matched = matchingRecords[0];
        } else {
          const db = await openIndexedDB();
          const transaction = db.transaction('studentData', 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const request = objectStore.getAll();

          matched = await new Promise((resolve) => {
            request.onsuccess = (event) => {
              const students = event.target.result;
              const found = students.find(student =>
                student &&
                String(student.registerNo).trim() === String(stdData.registerNo).trim()
              );
              resolve(found || null);
            };
            request.onerror = () => resolve(null);
          });
        }

        if (matched) {
          serialNoToUse = getSerialFromStudent(matched);
          if (!oldCurClass) setoldCurClass(matched.currentClass || '');
          if (!olddiv) setoldDiv(matched.division || '');
          setSelectedStudentData(matched);
        } else {
          try {
            const fbResponse = await fetch(
              `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`
            );
            if (fbResponse.ok) {
              const firebaseStudents = await fbResponse.json();
              if (firebaseStudents) {
                let matchedSerial = null;
                let matchedStudent = null;
                if (Array.isArray(firebaseStudents)) {
                  const found = firebaseStudents.find(
                    (s) => s && String(s.registerNo).trim() === String(stdData.registerNo).trim()
                  );
                  if (found) {
                    matchedStudent = found;
                    matchedSerial = found.serialNo || firebaseStudents.indexOf(found);
                  }
                } else {
                  const entry = Object.entries(firebaseStudents).find(
                    ([key, s]) => s && String(s.registerNo).trim() === String(stdData.registerNo).trim()
                  );
                  if (entry) {
                    matchedStudent = entry[1];
                    matchedSerial = entry[0];
                  }
                }
                if (matchedSerial) {
                  serialNoToUse = String(matchedSerial);
                  if (matchedStudent) {
                    if (!oldCurClass) setoldCurClass(matchedStudent.currentClass || '');
                    if (!olddiv) setoldDiv(matchedStudent.division || '');
                    setSelectedStudentData(matchedStudent);
                  }
                }
              }
            }
          } catch (fbErr) {
            console.error("Error fetching students from Firebase: ", fbErr);
          }
        }
      }

      if (!serialNoToUse) {
        setAlertMessage(language === 'English' ? "No student selected to update." : "अपडेट करण्यासाठी कोणताही विद्यार्थी निवडलेला नाही.");
        return;
      }

      const isRegisterNoChanged = !selectedStudentData || String(selectedStudentData.registerNo).trim() !== String(stdData.registerNo).trim();

      if (stdData.registerNo && isRegisterNoChanged) {
        const db = await openIndexedDB();
        const transaction = db.transaction('studentData', 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const request = objectStore.getAll();

        const isDuplicate = await new Promise((resolve) => {
          request.onsuccess = (event) => {
            const students = event.target.result;
            const getSerialFromStudent = (s) => {
              if (!s) return '';
              if (s.serialNo) return String(s.serialNo);
              if (s.id) {
                const parts = s.id.split('-');
                return parts[parts.length - 1];
              }
              return '';
            };
            const duplicate = students.some(student => {
              if (!student || !student.registerNo) return false;
              const studentRegisterNo = String(student.registerNo).trim();
              const targetRegisterNo = String(stdData.registerNo).trim();
              if (studentRegisterNo !== targetRegisterNo) return false;

              const studentSerial = getSerialFromStudent(student);
              return studentSerial !== String(serialNoToUse);
            });
            resolve(duplicate);
          };
          request.onerror = () => resolve(false);
        });

        if (isDuplicate) {
          setAlertMessage(language === 'English' ? "Register number already exists! Please use a unique register number." : "रजिस्टर क्रमांक आधीच अस्तित्वात आहे! कृपया एक अद्वितीय रजिस्टर क्रमांक वापरा.");
          return;
        }
      }

      const currentClassToSave = stdData.currentClass || currentClass;
      const admissionClassToSave = stdData.admissionClass || admissionClass;

      const dataPayload = {
        ...(stdData.bookno && { bookno: stdData.bookno }),
        ...(stdData.studentId && { studentId: stdData.studentId }),
        ...(stdData.aparId && { aparId: stdData.aparId }),
        ...(stdData.panId && { panId: stdData.panId }),
        ...(stdData.registerNo && { registerNo: stdData.registerNo }),
        ...(stdData.educationalYear && { educationalYear: stdData.educationalYear }),
        ...(stdData.ELGA && { ELGA: stdData.ELGA }),
        ...(stdData.stdSurname && { stdSurname: stdData.stdSurname }),
        ...(stdData.stdName && { stdName: stdData.stdName }),
        ...(stdData.stdFather && { stdFather: stdData.stdFather }),
        ...(stdData.stdMother && { stdMother: stdData.stdMother }),
        ...(stdData.stdAdharNo && { stdAdharNo: stdData.stdAdharNo }),
        ...(stdData.religion && { religion: stdData.religion }),
        ...(stdData.prevSchool && { prevSchool: stdData.prevSchool }),
        ...(stdData.division && { division: stdData.division }),
        ...(stdData.caste && { caste: stdData.caste }),
        ...(stdData.subCaste && { subCaste: stdData.subCaste }),
        ...(stdData.nationality && { nationality: stdData.nationality }),
        ...(stdData.motherTounge && { motherTounge: stdData.motherTounge }),
        ...(stdData.dateOfAdmission && { dateOfAdmission: stdData.dateOfAdmission }),
        ...(stdData.country && { country: stdData.country }),
        ...(stdData.state && { state: stdData.state }),
        ...(stdData.district && { district: stdData.district }),
        ...(stdData.taluka && { taluka: stdData.taluka }),
        ...(stdData.birthPlace && { birthPlace: stdData.birthPlace }),
        ...(stdData.gender && { gender: stdData.gender }),
        ...(stdData.NCCScout && { NCCScout: stdData.NCCScout }),
        ...(stdData.dob && { dob: stdData.dob }),
        ...(stdData.dobInWords && { dobInWords: stdData.dobInWords }),
        ...(stdData.mobileNo && { mobileNo: stdData.mobileNo }),
        ...(admissionClassToSave && { admissionClass: admissionClassToSave }),
        ...(currentClassToSave && { currentClass: currentClassToSave }),
        ...(stdData.isMinority && { isMinority: stdData.isMinority }),
        ...(stdData.isHosteller && { isHosteller: stdData.isHosteller }),
        ...(stdData.isRTE && { isRTE: stdData.isRTE }),
        ...(stdData.isAAY && { isAAY: stdData.isAAY }),
        ...(stdData.isScolar && { isScolar: stdData.isScolar }),
        ...(stdData.scolarName && { scolarName: stdData.scolarName }),
        ...(stdData.isBPL && { isBPL: stdData.isBPL }),
        ...(stdData.isCWSN && { isCWSN: stdData.isCWSN }),
        ...(stdData.casteCategory && { casteCategory: stdData.casteCategory }),
        ...(stdData.bloodGroup && { bloodGroup: stdData.bloodGroup }),
        ...(stdData.mOccupation && { mOccupation: stdData.mOccupation }),
        ...(stdData.fOccupation && { fOccupation: stdData.fOccupation }),
        ...(stdData.mMobile && { mMobile: stdData.mMobile }),
        ...(stdData.fMobile && { fMobile: stdData.fMobile }),
        ...(stdData.birthmark && { birthmark: stdData.birthmark }),
        ...(stdData.famIncome && { famIncome: stdData.famIncome }),
        ...(stdData.totalChildren && { totalChildren: stdData.totalChildren }),
        ...(stdData.birthOrder && { birthOrder: stdData.birthOrder }),
        ...(stdData.pAdhar && { pAdhar: stdData.pAdhar }),
        ...(stdData.address && { address: stdData.address }),
        ...(stdData.pincode && { pincode: stdData.pincode }),
        ...(stdData.prevPercent && { prevPercent: stdData.prevPercent }),
        ...(stdData.prevMarks && { prevMarks: stdData.prevMarks }),
        ...(stdData.adharmobileNo && { adharmobileNo: stdData.adharmobileNo }),
        ...(stdData.accHolderName && { accHolderName: stdData.accHolderName }),
        ...(stdData.accNo && { accNo: stdData.accNo }),
        ...(stdData.bankName && { bankName: stdData.bankName }),
        ...(stdData.branchName && { branchName: stdData.branchName }),
        ...(stdData.prevClass && { prevClass: stdData.prevClass }),
        ...(stdData.IFSC && { IFSC: stdData.IFSC }),
        ...(stdData.stdemailId && { stdemailId: stdData.stdemailId }),
        ...(stdData.prevLCDate && { prevLCDate: stdData.prevLCDate }),
        ...(stdData.fEducation && { fEducation: stdData.fEducation }),
        ...(stdData.mEducation && { mEducation: stdData.mEducation }),
        ...(stdData.distance && { distance: stdData.distance }),
        ...(stdData.disabilityName && { disabilityName: stdData.disabilityName }),
        ...(stdData.stdPhoto && { stdPhoto: stdData.stdPhoto }),
        isActive: stdData.isActive,
      };

      try {
        const db = await openIndexedDB(); // Open the IndexedDB
        const transaction = db.transaction('studentData', 'readwrite'); // Create a read-write transaction
        const objectStore = transaction.objectStore('studentData'); // Access the object store

        const oldClassToUse = oldCurClass || stdData.currentClass || currentClass;
        const oldDivToUse = olddiv || stdData.division || '';
        const oldKey = `${oldClassToUse}-${oldDivToUse}-${serialNoToUse}`;
        console.log("oldKey", oldKey);
        const div = stdData.division || '';

        // Fetch the existing record from IndexedDB
        const existingRecordRequest = objectStore.get(oldKey);

        existingRecordRequest.onsuccess = async (event) => {
          const existingRecord = event.target.result; // Get the existing record

          if (existingRecord) {
            // Merge existing record with new data
            const updatedRecord = { ...existingRecord, ...stdData, ...dataPayload, serialNo: Number(serialNoToUse) };

            // Construct the new key using the updated division
            const newKey = `${currentClassToSave}-${div}-${serialNoToUse}`;
            console.log("newKey", newKey);

            // Delete the existing record from IndexedDB using the old key
            const deleteRequest = objectStore.delete(oldKey);

            deleteRequest.onsuccess = async () => {
              // Add the updated record to IndexedDB using the new key
              const addRequest = objectStore.put({ ...updatedRecord, id: newKey }); // No key parameter needed

              addRequest.onsuccess = async () => {
                // Now update Firebase
                const firebaseResponse = await fetch(
                  `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNoToUse}.json`,
                  {
                    method: "PATCH", // Use PATCH instead of PUT
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dataPayload),
                  }
                );
                if (firebaseResponse.ok) {
                  await saveParentUser(serialNoToUse);
                  // Update classDiv in localStorage
                  const classDivDataRaw = localStorage.getItem('classDiv');
                  let classDivData = {};
                  if (classDivDataRaw) {
                    try {
                      classDivData = JSON.parse(classDivDataRaw);
                    } catch (err) {
                      classDivData = {};
                    }
                  }
                  // Check if the class exists in classDiv
                  if (!classDivData[currentClassToSave]) {
                    classDivData[currentClassToSave] = true; // Initialize if it doesn't exist
                  }
                  // If the class is currently true, do not change it unless adding a division
                  if (classDivData[currentClassToSave] === true) {
                    if (stdData.division) {
                      classDivData[currentClassToSave] = {}; // Convert to an object if adding a division
                      classDivData[currentClassToSave][stdData.division] = true; // Add the new division
                    }
                  } else {
                    // If the class already has divisions, only add the new division if it doesn't exist
                    if (stdData.division) {
                      classDivData[currentClassToSave][stdData.division] = true; // Add the new division
                    }
                  }
                  // Store the updated classDivData back to local storage
                  localStorage.setItem('classDiv', JSON.stringify(classDivData));

                  setAlertMessage(language === 'English' ? "Data updated successfully." : "माहिती यशस्वीरित्या अपडेट झाली.");
                  handleRegistrationSuccess();
                } else {
                  setAlertMessage(language === 'English' ? "Failed to update data" : "माहिती अपडेट करण्यात अयशस्वी");
                }
              };
              addRequest.onerror = (event) => {
                console.error("Error adding record :", event.target.error);
                setAlertMessage(language === 'English' ? "Failed to add record" : "रेकॉर्ड जोडण्यात अयशस्वी");
              };
            };

            deleteRequest.onerror = (event) => {
              console.error("Error deleting record :", event.target.error);
              setAlertMessage(language === 'English' ? "Failed to delete record" : "रेकॉर्ड डिलीट करण्यात अयशस्वी");
            };
          } else {
            console.log("No existing record found for the given key in IndexedDB. Performing direct update.");

            const newKey = `${currentClassToSave}-${div}-${serialNoToUse}`;
            console.log("newKey (direct update)", newKey);

            const updatedRecord = { ...stdData, ...dataPayload, serialNo: Number(serialNoToUse) };

            objectStore.delete(oldKey);

            const addRequest = objectStore.put({ ...updatedRecord, id: newKey });

            addRequest.onsuccess = async () => {
              const firebaseResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNoToUse}.json`,
                {
                  method: "PATCH",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(dataPayload),
                }
              );
              if (firebaseResponse.ok) {
                await saveParentUser(serialNoToUse);
                const classDivDataRaw = localStorage.getItem('classDiv');
                let classDivData = {};
                if (classDivDataRaw) {
                  try {
                    classDivData = JSON.parse(classDivDataRaw);
                  } catch (err) {
                    classDivData = {};
                  }
                }
                if (!classDivData[currentClassToSave]) {
                  classDivData[currentClassToSave] = true;
                }
                if (classDivData[currentClassToSave] === true) {
                  if (stdData.division) {
                    classDivData[currentClassToSave] = {};
                    classDivData[currentClassToSave][stdData.division] = true;
                  }
                } else {
                  if (stdData.division) {
                    classDivData[currentClassToSave][stdData.division] = true;
                  }
                }
                localStorage.setItem('classDiv', JSON.stringify(classDivData));

                setAlertMessage(language === 'English' ? "Data updated successfully." : "माहिती यशस्वीरित्या अपडेट झाली.");
                handleRegistrationSuccess();
              } else {
                setAlertMessage(language === 'English' ? "Failed to update data" : "माहिती अपडेट करण्यात अयशस्वी");
              }
            };

            addRequest.onerror = (event) => {
              console.error("Error adding record :", event.target.error);
              setAlertMessage(language === 'English' ? "Failed to add record" : "रेकॉर्ड जोडण्यात अयशस्वी");
            };
          }
        };

        existingRecordRequest.onerror = (event) => {
          console.error("Error fetching existing record :", event.target.error);
          setAlertMessage(language === 'English' ? "Failed to fetch existing record" : "विद्यमान रेकॉर्ड आणण्यात अयशस्वी");
        };
      } catch (error) {
        console.error("Error updating data:", error);
        setAlertMessage(language === 'English' ? "An error occurred while updating data" : "माहिती अपडेट करताना त्रुटी आली");
      }
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage(language === 'English' ? "Something went wrong, please try again." : "काहीतरी चुकले, कृपया पुन्हा प्रयत्न करा.");
      setSavingData(false); // Stop showing loading indicator
    }
  };


  const handleCloseReport = () => {
    setShowReport(false);
  };

  const handleReport = async () => {
    setShowReport(true);
  };

  const handleDelete = async () => {
    const confirmMessage = language === 'English'
      ? 'Are you sure you want to delete this student?'
      : 'तुम्हाला खात्री आहे का की तुम्ही या विद्यार्थ्याला डिलीट करू इच्छिता?';
    if (!window.confirm(confirmMessage)) {
      return;
    }
    try {
      let serialNoToUse = stdData.serialNo || serialNumberFromUrl || localStorage.getItem('selectedStudentSerialNo');

      if (!serialNoToUse && stdData.registerNo) {
        const getSerialFromStudent = (s) => {
          if (!s) return '';
          if (s.serialNo) return String(s.serialNo);
          if (s.id) {
            const parts = s.id.split('-');
            return parts[parts.length - 1];
          }
          return '';
        };

        let matched = null;
        if (matchingRecords && matchingRecords.length > 0) {
          matched = matchingRecords[0];
        } else {
          const db = await openIndexedDB();
          const transaction = db.transaction('studentData', 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const request = objectStore.getAll();

          matched = await new Promise((resolve) => {
            request.onsuccess = (event) => {
              const students = event.target.result;
              const found = students.find(student =>
                student &&
                String(student.registerNo).trim() === String(stdData.registerNo).trim()
              );
              resolve(found || null);
            };
            request.onerror = () => resolve(null);
          });
        }

        if (matched) {
          serialNoToUse = getSerialFromStudent(matched);
          if (!oldCurClass) setoldCurClass(matched.currentClass || '');
          if (!olddiv) setoldDiv(matched.division || '');
          setSelectedStudentData(matched);
        } else {
          try {
            const studentRef = ref(database, `schoolRegister/${udiseNumber}/studentData`);
            const snapshot = await get(studentRef);
            if (snapshot.exists()) {
              const firebaseStudents = snapshot.val();
              if (firebaseStudents) {
                let matchedSerial = null;
                let matchedStudent = null;
                if (Array.isArray(firebaseStudents)) {
                  const found = firebaseStudents.find(
                    (s) => s && String(s.registerNo).trim() === String(stdData.registerNo).trim()
                  );
                  if (found) {
                    matchedStudent = found;
                    matchedSerial = found.serialNo || firebaseStudents.indexOf(found);
                  }
                } else {
                  const entry = Object.entries(firebaseStudents).find(
                    ([key, s]) => s && String(s.registerNo).trim() === String(stdData.registerNo).trim()
                  );
                  if (entry) {
                    matchedStudent = entry[1];
                    matchedSerial = entry[0];
                  }
                }
                if (matchedSerial) {
                  serialNoToUse = String(matchedSerial);
                  if (matchedStudent) {
                    if (!oldCurClass) setoldCurClass(matchedStudent.currentClass || '');
                    if (!olddiv) setoldDiv(matchedStudent.division || '');
                    setSelectedStudentData(matchedStudent);
                  }
                }
              }
            }
          } catch (fbErr) {
            console.error("Error fetching students from Firebase: ", fbErr);
          }
        }
      }

      if (serialNoToUse) {
        const studentRef = ref(database, `schoolRegister/${udiseNumber}/studentData/${serialNoToUse}`);
        await remove(studentRef);

        setAlertMessage(language === 'English' ? 'Data deleted successfully!' : 'माहिती यशस्वीरित्या डिलीट केली!');

        const db = await openIndexedDB(); // Open the IndexedDB
        const transaction = db.transaction('studentData', 'readwrite'); // Create a read-write transaction
        const objectStore = transaction.objectStore('studentData'); // Access the object store

        const request = objectStore.getAll();

        const proceedWithUIDeletion = () => {
          console.log("Data deleted successfully from IndexedDB.");

          // Clear student reference from localStorage
          localStorage.removeItem("selectedStudentSerialNo");
          localStorage.removeItem("selectedStudentName");
          localStorage.removeItem("selectedStudentId");
          setRegisterNoExists(false);

          clearFormData(); // Clear the form data after successful deletion
          fetchSchoolData(); // Fetch updated school data

          if (serialNumberFromUrl) {
            navigate('/all-student-report'); // Redirect to the desired page
          } else {
            setTimeout(() => {
              window.location.href = "/student-register";
            }, 2500);
          }
        };

        request.onsuccess = (event) => {
          const studentData = event.target.result;
          const getSerialFromStudent = (s) => {
            if (!s) return '';
            if (s.serialNo) return String(s.serialNo);
            if (s.id) {
              const parts = s.id.split('-');
              return parts[parts.length - 1];
            }
            return '';
          };

          const matchingRecord = studentData.find(data => {
            if (!data) return false;
            const serial = getSerialFromStudent(data);
            return String(serial) === String(serialNoToUse);
          });

          if (matchingRecord && matchingRecord.id) {
            console.log("Found matching record in IndexedDB, deleting by ID:", matchingRecord.id);
            const deleteRequest = objectStore.delete(matchingRecord.id);
            deleteRequest.onsuccess = () => {
              proceedWithUIDeletion();
            };
            deleteRequest.onerror = (e) => {
              console.error("Error deleting record from IndexedDB:", e.target.error);
              setAlertMessage(language === 'English' ? "Failed to delete data from local storage" : "स्थानिक संचयनामधून माहिती डिलीट करण्यात अयशस्वी");
            };
          } else {
            // Fallback to constructed key
            const classToDelete = oldCurClass || stdData.currentClass || currentClass;
            const divToDelete = olddiv || stdData.division || '';
            const key = `${classToDelete}-${divToDelete}-${serialNoToUse}`;
            console.log("Record not found by serial search. Trying constructed key:", key);

            const deleteRequest = objectStore.delete(key);
            deleteRequest.onsuccess = () => {
              proceedWithUIDeletion();
            };
            deleteRequest.onerror = (e) => {
              console.error("Error deleting record from IndexedDB:", e.target.error);
              setAlertMessage(language === 'English' ? "Failed to delete data from local storage" : "स्थानिक संचयनामधून माहिती डिलीट करण्यात अयशस्वी");
            };
          }
        };

        request.onerror = (e) => {
          console.error("Error retrieving records from IndexedDB:", e.target.error);
          setAlertMessage(language === 'English' ? "Failed to delete data from local storage" : "स्थानिक संचयनामधून माहिती डिलीट करण्यात अयशस्वी");
        };
      } else {
        setAlertMessage(language === 'English' ? "No student selected to delete." : "डिलीट करण्यासाठी कोणताही विद्यार्थी निवडलेला नाही.");
      }
    } catch (error) {
      console.error('Error deleting data:', error);
      setAlertMessage(language === 'English' ? "Something went wrong, please try again." : "काहीतरी चुकले, कृपया पुन्हा प्रयत्न करा.");
    }
  };

  const [packType, setPackType] = useState("freeTrial");
  const [studentLimit, setStudentLimit] = useState(10);

  useEffect(() => {
    if (udiseNumber) {
      const dbRef = firebase.database().ref(`/Admin/${udiseNumber}`);
      dbRef.once("value")
        .then((snapshot) => {
          const data = snapshot.val();
          const pack = data?.packActivated || "freeTrial";
          setPackType(pack);

          switch (pack) {
            case "silver":
              setStudentLimit(100);
              break;
            case "gold":
              setStudentLimit(500);
              break;
            case "platinum":
              setStudentLimit(1000);
              break;
            case "platinum plus":
            case "purchase":
            case undefined:
            case null:
            case "":
            case "freeTrial": // If you want free trial to also have unlimited
              setStudentLimit(Infinity); // Unlimited students
              break;
            default:
              setStudentLimit(10);
          }
        })
        .catch((error) => {
          console.error("Error fetching pack activation status:", error);
        });
    }
  }, [udiseNumber]);

  const saveParentUser = async (serialNoToUse) => {
    const parentMobile = String(stdData.mobileNo || stdData.fMobile || stdData.mMobile || stdData.adharmobileNo || "").trim();
    if (!parentMobile) {
      return;
    }

    let currentSchoolName = schoolName || localStorage.getItem("schoolName") || "";
    if (!currentSchoolName && udiseNumber) {
      try {
        const sResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`);
        const sData = await sResponse.json();
        if (sData && sData.schoolName) {
          currentSchoolName = sData.schoolName;
          setSchoolName(currentSchoolName);
        }
      } catch (err) {
        console.error("Error fetching school name:", err);
      }
    }

    const fullName = `${stdData.stdName || ""} ${stdData.stdFather || ""} ${stdData.stdSurname || ""}`.replace(/\s+/g, ' ').trim();
    const currentClassVal = stdData.currentClass || currentClass || "";

    // 1. Fetch existing parent node (if multiple children exist under this parent mobile)
    let existingStudents = {};
    try {
      const existingParentRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/parent/${parentMobile}.json`
      );
      if (existingParentRes.ok) {
        const existingParent = await existingParentRes.json();
        if (existingParent && existingParent.students) {
          existingStudents = { ...existingParent.students };
        }
      }
    } catch (fetchErr) {
      console.warn("Could not fetch existing parent node:", fetchErr);
    }

    existingStudents[String(serialNoToUse)] = {
      studentName: fullName,
      registerNo: String(stdData.registerNo || ""),
      serialNo: String(serialNoToUse || ""),
      studentId: String(stdData.studentId || ""),
      aparId: String(stdData.aparId || ""),
      panId: String(stdData.panId || ""),
      currentClass: String(currentClassVal),
      division: String(stdData.division || ""),
      rollNo: String(stdData.rollNo || ""),
      dob: String(stdData.dob || ""),
      gender: String(stdData.gender || ""),
      caste: String(stdData.caste || ""),
      religion: String(stdData.religion || ""),
    };

    // 2. Complete Parent Node Data (only stored in parent nodes, NOT in user node)
    const parentNodeData = {
      mobileNumber: String(parentMobile),
      name: fullName,
      studentName: fullName,
      fatherName: String(stdData.stdFather || stdData.fName || ""),
      motherName: String(stdData.stdMother || stdData.mName || ""),
      fatherMobile: String(stdData.fMobile || ""),
      motherMobile: String(stdData.mMobile || ""),
      registerNo: String(stdData.registerNo || ""),
      serialNo: String(serialNoToUse || ""),
      studentId: String(stdData.studentId || ""),
      aparId: String(stdData.aparId || ""),
      panId: String(stdData.panId || ""),
      currentClass: String(currentClassVal),
      division: String(stdData.division || ""),
      rollNo: String(stdData.rollNo || ""),
      dob: String(stdData.dob || ""),
      gender: String(stdData.gender || ""),
      caste: String(stdData.caste || ""),
      religion: String(stdData.religion || ""),
      parentAdhaar: String(stdData.oneParentAdharNo || stdData.fAdharNo || stdData.mAdharNo || ""),
      studentAdhaar: String(stdData.stdAdharNo || ""),
      occupation: String(stdData.parentsOccupation || stdData.fOccupation || stdData.mOccupation || ""),
      income: String(stdData.parentsIncome || stdData.fIncome || stdData.mIncome || ""),
      address: [stdData.taluka, stdData.district, stdData.state].filter(Boolean).join(", "),
      schoolName: currentSchoolName || "",
      udiseNumber: String(udiseNumber || ""),
      role: "parent",
      status: "active",
      addedBy: String(localStorage.getItem("userName") || localStorage.getItem("role") || "teacher"),
      addedByRole: String(localStorage.getItem("role") || "teacher"),
      updatedAt: new Date().toISOString(),
      students: existingStudents,
    };

    try {
      // Store under root /parent/{parentMobile} node in Firebase
      await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/parent/${parentMobile}.json`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(parentNodeData),
        }
      );

      // Store under schoolRegister/{udiseNumber}/parents/{parentMobile} node in Firebase
      if (udiseNumber) {
        await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/parents/${parentMobile}.json`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(parentNodeData),
          }
        );
      }
    } catch (error) {
      console.error("Error saving parent node in Firebase:", error);
    }
  };

  const handleRegister = async () => {

    setSavingData(true);
    setFormSubmitted(true);
    const currentClassToSave = stdData.currentClass || currentClass;
    const admissionClassToSave = stdData.admissionClass || admissionClass;


    if (!stdData.registerNo || !stdData.stdName || !currentClassToSave) {
      setAlertMessage("Please fill in all required fields: Current Class, Register No, Student Name.");
      setSavingData(false);
      return;
    }

    try {
      const db = await openIndexedDB();
      const transaction = db.transaction('studentData', 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const request = objectStore.getAll();

      const isDuplicate = await new Promise((resolve) => {
        request.onsuccess = (event) => {
          const students = event.target.result;
          const currentSerial = stdData.serialNo;
          const duplicate = students.some(student =>
            student &&
            student.registerNo === stdData.registerNo &&
            (!currentSerial || String(student.serialNo) !== String(currentSerial))
          );
          resolve(duplicate);
        };
        request.onerror = () => resolve(false);
      });

      if (isDuplicate) {
        setAlertMessage(language === 'English' ? "Register number already exists! Please use a unique register number." : "रजिस्टर क्रमांक आधीच अस्तित्वात आहे! कृपया एक अद्वितीय रजिस्टर क्रमांक वापरा.");
        setSavingData(false);
        return;
      }
    } catch (err) {
      console.error("Error checking register number uniqueness:", err);
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`);
      const lastAddedSerialNo = await response.json();

      if (lastAddedSerialNo >= studentLimit) {
        setAlertMessage(`Your current plan (${packType}) allows only up to ${studentLimit} students.`);
        setSavingData(false);
        return;
      }

      let serialNo = lastAddedSerialNo || 0;
      serialNo++;

      await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastAddedSerialNo.json`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(serialNo),
      });



      const dataPayload = {
        serialNo,
        ...(stdData.bookno && { bookno: stdData.bookno }),
        ...(stdData.studentId && { studentId: stdData.studentId }),
        ...(stdData.aparId && { aparId: stdData.aparId }),
        ...(stdData.panId && { panId: stdData.panId }),
        ...(stdData.registerNo && { registerNo: stdData.registerNo }),
        ...(stdData.educationalYear && { educationalYear: stdData.educationalYear }),
        ...(stdData.ELGA && { ELGA: stdData.ELGA }),
        ...(stdData.stdSurname && { stdSurname: stdData.stdSurname }),
        ...(stdData.stdName && { stdName: stdData.stdName }),
        ...(stdData.stdFather && { stdFather: stdData.stdFather }),
        ...(stdData.stdMother && { stdMother: stdData.stdMother }),
        ...(stdData.stdAdharNo && { stdAdharNo: stdData.stdAdharNo }),
        ...(stdData.religion && { religion: stdData.religion }),
        ...(stdData.prevSchool && { prevSchool: stdData.prevSchool }),
        ...(stdData.division && { division: stdData.division }),
        ...(stdData.caste && { caste: stdData.caste }),
        ...(stdData.subCaste && { subCaste: stdData.subCaste }),
        ...(stdData.nationality && { nationality: stdData.nationality }),
        ...(stdData.motherTounge && { motherTounge: stdData.motherTounge }),
        ...(stdData.dateOfAdmission && { dateOfAdmission: stdData.dateOfAdmission }),
        ...(stdData.country && { country: stdData.country }),
        ...(stdData.state && { state: stdData.state }),
        ...(stdData.district && { district: stdData.district }),
        ...(stdData.taluka && { taluka: stdData.taluka }),
        ...(stdData.birthPlace && { birthPlace: stdData.birthPlace }),
        ...(stdData.gender && { gender: stdData.gender }),
        ...(stdData.NCCScout && { NCCScout: stdData.NCCScout }),
        ...(stdData.dob && { dob: stdData.dob }),
        ...(stdData.dobInWords && { dobInWords: stdData.dobInWords }),
        ...(stdData.mobileNo && { mobileNo: stdData.mobileNo }),
        ...(admissionClassToSave && { admissionClass: admissionClassToSave }),
        ...(currentClassToSave && { currentClass: currentClassToSave }),
        ...(stdData.isMinority && { isMinority: stdData.isMinority }),
        isActive: !!stdData.isActive,
        ...(stdData.isHosteller && { isHosteller: stdData.isHosteller }),
        ...(stdData.isRTE && { isRTE: stdData.isRTE }),
        ...(stdData.isAAY && { isAAY: stdData.isAAY }),
        ...(stdData.isScolar && { isScolar: stdData.isScolar }),
        ...(stdData.scolarName && { scolarName: stdData.scolarName }),
        ...(stdData.isBPL && { isBPL: stdData.isBPL }),
        ...(stdData.isCWSN && { isCWSN: stdData.isCWSN }),
        ...(stdData.casteCategory && { casteCategory: stdData.casteCategory }),
        ...(stdData.bloodGroup && { bloodGroup: stdData.bloodGroup }),
        ...(stdData.mOccupation && { mOccupation: stdData.mOccupation }),
        ...(stdData.fOccupation && { fOccupation: stdData.fOccupation }),
        ...(stdData.mMobile && { mMobile: stdData.mMobile }),
        ...(stdData.fMobile && { fMobile: stdData.fMobile }),
        ...(stdData.birthmark && { birthmark: stdData.birthmark }),
        ...(stdData.famIncome && { famIncome: stdData.famIncome }),
        ...(stdData.totalChildren && { totalChildren: stdData.totalChildren }),
        ...(stdData.birthOrder && { birthOrder: stdData.birthOrder }),
        ...(stdData.pAdhar && { pAdhar: stdData.pAdhar }),
        ...(stdData.address && { address: stdData.address }),
        ...(stdData.pincode && { pincode: stdData.pincode }),
        ...(stdData.prevPercent && { prevPercent: stdData.prevPercent }),
        ...(stdData.prevMarks && { prevMarks: stdData.prevMarks }),
        ...(stdData.adharmobileNo && { adharmobileNo: stdData.adharmobileNo }),
        ...(stdData.accHolderName && { accHolderName: stdData.accHolderName }),
        ...(stdData.accNo && { accNo: stdData.accNo }),
        ...(stdData.bankName && { bankName: stdData.bankName }),
        ...(stdData.branchName && { branchName: stdData.branchName }),
        ...(stdData.prevClass && { prevClass: stdData.prevClass }),
        ...(stdData.IFSC && { IFSC: stdData.IFSC }),
        ...(stdData.stdemailId && { stdemailId: stdData.stdemailId }),
        ...(stdData.prevLCDate && { prevLCDate: stdData.prevLCDate }),
        ...(stdData.fEducation && { fEducation: stdData.fEducation }),
        ...(stdData.mEducation && { mEducation: stdData.mEducation }),
        ...(stdData.distance && { distance: stdData.distance }),
        ...(stdData.disabilityName && { disabilityName: stdData.disabilityName }),
        ...(stdData.stdPhoto && { stdPhoto: stdData.stdPhoto }),
      };


      const classtosave = selectedClass || currentClass

      const classDivData = JSON.parse(localStorage.getItem('classDiv')) || {};
      if (!classDivData[classtosave]) {
        classDivData[classtosave] = true; // Set to true if class has no divisions
      }

      if (division) {
        if (classDivData[classtosave] === true) {
          classDivData[classtosave] = {}; // Convert to an object
        }

        classDivData[classtosave][division] = true; // Set division to true
      }
      localStorage.setItem('classDiv', JSON.stringify(classDivData));

      // Open IndexedDB and fetch the existing record
      const db = await openIndexedDB(); // Open the IndexedDB
      const transaction = db.transaction('studentData', 'readwrite'); // Create a read-write transaction
      const objectStore = transaction.objectStore('studentData'); // Access the object store

      // Construct the key using currentClass, division, and serialNo
      const key = `${currentClassToSave}-${stdData.division || ''}-${serialNo}`

      // Fetch the existing record from IndexedDB
      const existingRecordRequest = objectStore.get(key);

      existingRecordRequest.onsuccess = async (event) => {
        const existingRecord = event.target.result; // Get the existing record

        // Merge existing record with new data
        const updatedRecord = existingRecord ? { ...existingRecord, ...dataPayload } : dataPayload;

        // Update the record in IndexedDB
        const updateRequest = objectStore.put({ ...updatedRecord, id: key }); // Use the merged record

        updateRequest.onsuccess = async () => {

          // Now save the data to Firebase
          const firebaseResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataPayload),
            }
          );

          if (firebaseResponse.ok) {
            await saveParentUser(serialNo);
            setAlertMessage("Student data stored successfully.");
            clearFormData(); // Clear the form data after successful update
          } else {
            setAlertMessage("Failed to store student data");
          }
        };

        updateRequest.onerror = (event) => {
          console.error("Error updating data :", event.target.error);
          setAlertMessage("Failed to update data ");
        };
      };

      existingRecordRequest.onerror = (event) => {
        console.error("Error fetching existing record :", event.target.error);
        setAlertMessage("Failed to fetch record");
      };

      if (logoFile) {
        const storageRef = firebase.storage().ref();
        const uploadTask = storageRef.child(`${udiseNumber}/student${serialNo}`).put(logoFile);


        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            console.log("Upload is " + progress + "% done");
            setProgress(progress)
          },
          (error) => {
            console.error("Error uploading logo:", error);
            setAlertMessage("Failed to upload logo");
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(async (downloadURL) => {
              dataPayload.stdPhoto = downloadURL; // Set the new photo URL

              // Save the dataPayload to Firebase
              const response = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`,
                {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(dataPayload),
                }
              );

              if (response.ok) {
                await saveParentUser(serialNo);
                setAlertMessage("Student data stored successfully");
                clearFormData();
                setSavingData(false);
                handleRegistrationSuccess();
              } else {
                setAlertMessage("Failed to store student data");
                setSavingData(false);
              }
            });
          }
        );
      } else {
        // If no logo file is provided, just save to Firebase
        try {
          const response = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataPayload),
            }
          );

          if (response.ok) {
            await saveParentUser(serialNo);
            setAlertMessage("Student data stored successfully");
            fetchSchoolData(); // Fetch updated school data
            handleRegistrationSuccess();
          } else {
            setAlertMessage("Failed to store student data");
          }
        } catch (error) {
          console.error("Error:", error);
          setAlertMessage("An error occurred while saving student data");
        } finally {
          setSavingData(false); // Stop showing loading indicator
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Something went wrong, please try again.");
      setSavingData(false); // Stop showing loading indicator
    }
  };

  const handleBackCancelButtonClick = () => {
    if (serialNumberFromUrl) {
      navigate(-1);
    } else {
      clearFormData();
    }
  };

  const closeButtonClick = () => {

    setShowNewBookForm(false);
    setShowCasteInput(false);
    setShowNewAdmissionClassForm(false);
    // setShowNewCountryForm(false);
    setShowNewCurrentClassForm(false);
    setShowNewEducationalYearForm(false);
    setShowNewELGAForm(false);
    setShowNewNationalityForm(false);
    setShowNewMotherToungeForm(false);
    setShowNewCasteForm(false);
    setShowNewReligionForm(false);
    setShowNewPrevSchoolForm(false);
    setShowNewDivisionForm(false);
    // setShowNewStateForm(false);

    setIsEditingReligion(false);
    setIsEditingPrevSchool(false);
    setEditReligionIndex(null);
    setEditPrevSchoolIndex(null);
    setNewReligion('');
    setNewPrevSchool('');
    // setIsEditingCountry(false);
    // setEditCountryIndex(null);
    // setNewCountry(''); 
    setIsEditingNationality(false);
    setEditNationalityIndex(null);
    setNewNationality('');
    setIsEditingMotherTounge(false);
    setEditMotherToungeIndex(null);
    setNewMotherTounge('');
    setIsEditingCaste(false);
    setEditCasteIndex(null);
    setNewCaste('');
    setIsEditingDivision(false);
    setEditDivisionIndex(null);
    setNewDivision('');
  };
  const closeButtonClick2 = () => {
    skipDuplicateCheck.current = true;
    const currentRegisterNo = stdData.registerNo;
    setRegisterNoExists(false);
    setShowMatchingRecords(false);

    clearFormData();

    setStdData(prevState => ({
      ...prevState,
      registerNo: currentRegisterNo,
    }));
  };

  const clearFormData = () => {
    setStdData(prevState => ({
      ...prevState,
      studentId: "",
      aparId: "",
      panId: "",
      educationalYear: "",
      ELGA: "",
      stdSurname: "",
      stdName: "",
      stdFather: "",
      stdMother: "",
      stdAdharNo: "",
      religion: "",
      prevSchool: "",
      division: "",
      caste: "",
      subCaste: "",
      nationality: "",
      motherTounge: "",
      category: "",
      dateOfAdmission: "",
      country: "",
      state: "",
      district: "",
      taluka: "",
      birthPlace: "",
      gender: "",
      NCCScout: "",
      dob: "",
      dobInWords: "",
      mobileNo: "",
      admissionClass: admissionClass,
      currentClass: currentClass,
      stdPhoto: '',
      registerNo: '',
      bloodGroup: '',
      fOccupation: '',
      mOccupation: '',
      mMobile: '',
      fMobile: '',
      isHosteller: '',
      isRTE: '',
      isScolar: '',
      isBPL: '',
      isCWSN: '',
      isAAY: '',
      birthmark: '',
      famIncome: '',
      totalChildren: '',
      birthOrder: '',
      pAdhar: '',
      address: '',
      pincode: '',
      prevPercent: '',
      prevMarks: '',
      adharmobileNo: '',
      accHolderName: '',
      accNo: '',
      bankName: '',
      branchName: '',
      prevClass: '',
      IFSC: '',
      stdemailId: '',
      prevLCDate: '',
      fEducation: '',
      mEducation: '',
      distance: '',
      disabilityName: '',
      serialNo: '',
    }));
    setBookNumber('')
    setDivision('')
    setState('')
    setReligion('')
    setPrevSchool('')
    setCasteCategory("");
    setEducationalYear('')
    setELGA('')
    setAdmissionClass(admissionClass)
    setCurrentClass(currentClass)
    setNationality('')
    setMotherTounge('')
    setCountry('')
    setGender('')
    setNCCScout('')
    setLogoFile('')
    setLogoURL('')
    setSelectedDistrict('')
    setSelectedTaluka('')
    setIsMinority(false);
    setIsActive(true);
    setIsHosteller('');
    setIsRTE('');
    setIsScolar('');
    setIsBPL('');
    setIsCWSN('');
    setIsAAY('');
  };

  const handleRegistrationSuccess = () => {
    localStorage.removeItem("selectedStudentSerialNo");
    localStorage.removeItem("selectedStudentName");
    localStorage.removeItem("selectedStudentId");
    setRegisterNoExists(false);
    clearFormData();
    setTimeout(() => {
      if (serialNumberFromUrl) {
        navigate('/all-student-report');
      } else {
        window.location.href = "/student-register";
      }
    }, 2500);
  };

  const handleRowClickDivision = (index) => {
    setIsEditingDivision(true);
    setEditDivisionIndex(index);
    setNewDivision(divisions[index]);
    setShowNewDivisionForm(true);
  };


  const handleRowClickMotherTounge = (index) => {
    setIsEditingMotherTounge(true);
    setEditMotherToungeIndex(index);
    setNewMotherTounge(motherTounges[index]);
    setShowNewMotherToungeForm(true);
  };
  const handleRowClickCaste = (index) => {
    setIsEditingCaste(true);
    setEditCasteIndex(index);
    setNewCaste(motherTounges[index]);
    setShowNewCasteForm(true);
  };
  const handleRowClickNationality = (index) => {
    setIsEditingNationality(true);
    setEditNationalityIndex(index);
    setNewNationality(nationalities[index]);
    setShowNewNationalityForm(true);
  };

  const handleRowClickPrevSchool = (index) => {
    setIsEditingPrevSchool(true);
    setEditPrevSchoolIndex(index);
    setNewPrevSchool(prevSchools[index]);
    setShowNewPrevSchoolForm(true);
  };

  const handleRowClickReligion = (index) => {
    setIsEditingReligion(true);
    setEditReligionIndex(index);
    setNewReligion(religions[index]);
    setShowNewReligionForm(true);
  };


  useEffect(() => {
    if (stdData.serialNo) {

      const documentsRef = ref(database, `schoolRegister/${udiseNumber}/studentData/${stdData.serialNo}/documents`);
      get(documentsRef).then((snapshot) => {
        if (snapshot.exists()) {
          setSavedDocuments(Object.values(snapshot.val()));
        } else {
          setSavedDocuments([]);
        }
      });
    }
  }, [stdData.serialNo, udiseNumber]);



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
    }
  }
  const handleAddDocument = async () => {
    if (!documentType || !selectedFile) {
      alert("Please select a file and document type.");
      return;
    }

    try {
      if (!stdData.serialNo) {
        alert("Student data is missing., Please first save Student.");
        return;
      }

      const filePath = `${udiseNumber}/studentsdoc/${stdData.serialNo}/${documentType}/${fileName}`;
      const fileRef = storageRef(storage, filePath);

      await uploadBytes(fileRef, selectedFile);
      const fileURL = await getDownloadURL(fileRef);

      const docRef = ref(database, `schoolRegister/${udiseNumber}/studentData/${stdData.serialNo}/documents`);
      const newDocRef = push(docRef);
      const newDocument = { documentType, fileName, fileURL };

      await set(newDocRef, newDocument);
      setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);

      setSelectedFile(null);
      setFileName("");
      setDocumentType("");

      // Clear file input field
      document.getElementById("fileInput").value = "";

    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };


  const handleViewDocument = (url) => {
    setViewFileURL(url);
  };

  const handleShowDocument = () => {
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setViewFileURL(previewUrl);
      return;
    }

    if (documentType) {
      const matched = savedDocuments && savedDocuments.find((d) => d && d.documentType === documentType);
      if (matched && matched.fileURL) {
        setViewFileURL(matched.fileURL);
        return;
      }
    }

    if (savedDocuments && savedDocuments.length > 0) {
      const validDoc = savedDocuments.find(d => d && d.fileURL);
      if (documentType) {
        alert(language === 'English' ? `No ${documentType} uploaded yet.` : `अद्याप ${documentType} अपलोड केले नाही.`);
      } else if (validDoc) {
        setViewFileURL(validDoc.fileURL);
      }
      return;
    }

    alert(language === 'English' ? "No document uploaded yet." : "कोणतेही दस्तऐवज अपलोड केलेले नाही.");
  };

  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };



  const handleDeleteDocument = async (doc) => {
    const confirmMessage = language === 'English'
      ? 'Are you sure you want to delete this document?'
      : 'तुम्हाला खात्री आहे का की तुम्ही हे दस्तऐवज डिलीट करू इच्छिता?';
    if (!window.confirm(confirmMessage)) {
      return;
    }
    const { fileURL, documentType, fileName } = doc;

    try {
      // Reference to the document list in Realtime Database
      const docRef = ref(database, `schoolRegister/${udiseNumber}/studentData/${stdData.serialNo}/documents`);
      const documentSnapshot = await get(docRef);
      const documents = documentSnapshot.val();

      // Find the document key to delete
      const documentKey = Object.keys(documents).find(key => documents[key].fileURL === fileURL);
      if (documentKey) {
        await remove(ref(database, `schoolRegister/${udiseNumber}/studentData/${stdData.serialNo}/documents/${documentKey}`));
      }

      // Construct the file path in Firebase Storage
      const filePath = `${udiseNumber}/studentsdoc/${stdData.serialNo}/${documentType}/${fileName}`;
      const fileRef = storageRef(storage, filePath);

      // Delete the file from Firebase Storage
      await deleteObject(fileRef);

      // Update the savedDocuments state
      setSavedDocuments((prevDocuments) => prevDocuments.filter(d => d.fileURL !== fileURL));


      // Set alert message after successful deletion
      setAlertMessage("Document deleted successfully!");

    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };



  useEffect(() => {
    const fetchStudentBySerialNo = async () => {
      const selectedSerialNo = localStorage.getItem('selectedStudentSerialNo');
      if (selectedSerialNo && !serialNumberFromUrl) { // Avoid conflict with URL-based serialNo
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const request = objectStore.getAll();

          request.onsuccess = (event) => {
            const data = event.target.result;
            // Fetch data based on serialNo, not registerNo
            const matchingRecord = data.find(record => record && record.serialNo && record.serialNo.toString() === selectedSerialNo);

            if (matchingRecord) {
              // Update stdData and other state variables with fetched data
              updateFieldsAndState(matchingRecord);
              setSelectedStudentData(matchingRecord);
              setShowMatchingRecords(false);
              setoldDiv(matchingRecord.division || '');
              setoldCurClass(matchingRecord.currentClass || '');
              handleStateChange({ target: { value: matchingRecord.state } });

            } else {
              console.log("No student found for selectedStudentSerialNo:", selectedSerialNo);
            }
          };

          request.onerror = (event) => {
            console.error("Error fetching student data:", event.target.error);
          };
        } catch (error) {
          console.error("Error accessing IndexedDB:", error);
        }
      }
    };

    fetchStudentBySerialNo();
  }, [serialNumberFromUrl]);
  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className="main-content-of-page">
        <div className="row">
          <div className="col-lg-10 col-xl-10 stduent-register">
            <div
              className="card text-black"
              style={{ borderRadius: "20px" }}
            >
              <h3 className='text-center mb-3 mt-2' style={{ color: '#03365e', fontWeight: '600' }}>
                {(registerNoExists || stdData.serialNo || serialNumberFromUrl)
                  ? (language === 'English' ? 'Update Student Details' : 'विद्यार्थ्याची माहिती अपडेट करा')
                  : (language === 'English' ? 'Register New Student' : 'नवीन विद्यार्थी नोंदणी')}
              </h3>

              <div className="card-body">
                <div className="row justify-content-center">
                  <form className="mx-1 mx-md-3 row">
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Book No' : 'पुस्तक क्र.'}

                        </label>
                        <select
                          name="bookno"
                          className="form-select"
                          onChange={handleBookNumChange} onFocus={() => handleFocus(0)}
                          ref={(el) => (inputs.current[0] = el)}
                          value={bookno}
                        >
                          <option value="">   {language === 'English' ? 'Select Book No' : 'पुस्तक क्र. निवडा'}</option>
                          {bookNumbers.sort((a, b) => a - b).map((bNumber, index) => (
                            <option key={index} value={bNumber}>
                              {bNumber}
                            </option>
                          ))}

                          <option value="addNewBook" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? 'Add New Book Number' : 'नवीन पुस्तक क्रमांक जोडा'}
                          </option>
                        </select>
                      </div>
                    </div>

                    {showNewBookForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newBookInput">
                              {language === 'English' ? 'Enter new book number:' : 'नवीन पुस्तक क्रमांक प्रविष्ट करा:'}
                            </label>

                            <input
                              type="text"
                              id="newBookInput"
                              className="newRegInput"
                              value={newBookNumber}
                              onChange={(e) =>
                                setNewBookNumber(e.target.value)
                              }
                            />
                            <button className="registerNewSaveBtn" onClick={handleNewBookSubmit}>
                              {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                            </button>
                            <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>


                            {bookNumbers.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>
                                        {language === 'English' ? 'Book Numbers' : 'पुस्तक क्रमांक'}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {bookNumbers.map((bNumber, index) => (
                                      <tr key={index}>
                                        <td>{bNumber}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? 'Register NO' : 'रजिस्टर क्र.'}
                        </label>
                        <input
                          autoComplete="off"
                          type="text" onFocus={() => handleFocus(1)}
                          ref={(el) => (inputs.current[1] = el)}
                          name="registerNo"
                          onChange={handleTextChange}
                          onKeyDown={(event) => {
                            if (language === 'Marathi' && event.key === 'Tab') {
                              event.preventDefault();
                              const nextInputField = document.querySelector('input[name="studentId"]');
                              nextInputField.focus();
                            }
                          }}
                          onKeyPress={handleEnterKey}
                          value={stdData.registerNo.trim()}
                          className="form-control"

                        />
                      </div>
                      <div className="centerReg">
                        {showMatchingRecords && registerNoExists && matchingRecords.length > 0 && (
                          <div className="overlay">
                            <div className="center-form">
                              <div className="new-book-form table-responsive" style={{ width: '400px' }} >
                                <button className="registerNewCloseBtn" onClick={closeButtonClick2}><CloseIcon /></button>
                                <table className="record-tableReg">
                                  <thead>
                                    <tr>
                                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Name</th>
                                      <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Class</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {matchingRecords.map((record, index) => (
                                      <tr key={index} onClick={() => handleRecordSelection(record)} className="record-rowReg">
                                        <td>{record.stdName} {record.stdFather} {record.stdSurname}</td>
                                        <td>{record.currentClass}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Student SARAL ID' : 'विद्यार्थी सरल आयडी'}

                        </label>


                        <input
                          type="number"
                          name="studentId" onFocus={() => handleFocus(2)}
                          ref={(el) => (inputs.current[2] = el)}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Check if the value length is less than or equal to 19
                            if (value.length <= 19) {
                              handleTextChange(e); // Call your change handler
                            }
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 19) {
                              e.preventDefault();
                            }
                            handleEnterKey(e); // Call your key press handler
                          }}
                          value={stdData.studentId}
                          className="form-control"
                          autoComplete="off"
                        />



                      </div>
                    </div>
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Student APAAR ID' : 'विद्यार्थी अपार आयडी'}

                        </label>
                        <input
                          type="number"
                          name="aparId" onFocus={() => handleFocus(3)}
                          ref={(el) => (inputs.current[3] = el)}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Check if the value length is less than or equal to 19
                            if (value.length <= 12) {
                              handleTextChange(e); // Call your change handler
                            }
                          }}
                          onKeyPress={(e) => {
                            if (e.target.value.length >= 12) {
                              e.preventDefault();
                            }
                            handleEnterKey(e); // Call your key press handler
                          }}
                          value={stdData.aparId}
                          className="form-control"
                          autoComplete="off"
                        />

                      </div>
                    </div>
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label className="form-label" htmlFor="form3Example1c">
                          {language === 'English' ? 'Student PEN' : 'विद्यार्थी PEN'}
                        </label>
                        <input
                          type="text"
                          name="panId" onFocus={() => handleFocus(4)}
                          ref={(el) => (inputs.current[4] = el)}
                          onChange={handleTextChange}
                          onKeyPress={handleEnterKey}
                          value={stdData.panId}
                          className="form-control"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? 'Educational Year' : 'शैक्षणिक वर्ष'}
                        </label>
                        <select
                          name="educationalYear"
                          className={`form-select ${formSubmitted && educationalYear === "" ? "input-error" : ""}`} onFocus={() => handleFocus(5)}
                          ref={(el) => (inputs.current[5] = el)}
                          onChange={handleEduYearChange}
                          value={educationalYear}
                        >
                          <option value="">{language === 'English' ? 'Select Education Year' : 'शैक्षणिक वर्ष निवडा'}</option>

                          <option value="2023-2024">2023-2024</option>
                          <option value="2024-2025">2024-2025</option>
                          <option value="2025-2026">2025-2026</option>
                          <option value="2026-2027">2026-2027</option>
                          <option value="2027-2028">2027-2028</option>
                          <option value="2028-2029">2028-2029</option>
                          <option value="2029-2030">2029-2030</option>
                          <option value="2030-2031">2030-2031</option>

                          {educationalYears
                            .filter(year =>
                              !['2023-2024', '2024-2025', '2025-2026', '2026-2027', '2027-2028', '2028-2029', '2030-2031'].includes(year)
                            )
                            .sort((a, b) => parseInt(a.split('-')[0]) - parseInt(b.split('-')[0]))
                            .map((year, index) => (
                              <option key={index} value={year}>
                                {year}
                              </option>
                            ))}

                          <option value="addNewEducationalYear" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? 'Add New Education Year (eg. 2025-2026)' : 'नवीन शैक्षणिक वर्ष निवडा (eg. 2025-2026)'}
                          </option>
                        </select>
                      </div>
                    </div>
                    {showNewEducationalYearForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newEducationalYearInput">
                              {language === 'English' ? ' Enter New EducationalYear: ' : 'नवीन शैक्षणिक वर्ष निवडा:'}

                            </label>
                            <input
                              type="text"
                              className="newRegInput"
                              id="newEducationalYearInput"
                              value={newEducationalYear}
                              onChange={(e) =>
                                setNewEducationalYear(e.target.value)
                              }
                            />
                            <button className="registerNewSaveBtn"
                              onClick={handleNewEducationalYearSubmit}
                            >
                              {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                            </button>
                            <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                            {educationalYears.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>  {language === 'English' ? 'Educational Year' : 'शैक्षणिक वर्ष'}</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    {educationalYears.map(
                                      (educationalYear, index) => (
                                        <tr key={index}>
                                          <td>{educationalYear}</td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Admission Class' : 'प्रवेश वर्ग'}
                        </label>
                        <select
                          name="admissionClass"
                          className={`form-select ${formSubmitted && admissionClass === "" ? "input-error" : ""}`}
                          onChange={handleAdmissionClassChange} onFocus={() => handleFocus(12)}
                          ref={(el) => (inputs.current[12] = el)}
                          value={admissionClass}
                        >
                          <option value=""> {language === 'English' ? ' Select Admission Class ' : 'प्रवेश वर्ग निवडा'}</option>
                          <option value={language === 'English' ? 'Class I' : 'इयत्ता पहिली'}> {language === 'English' ? ' Class I ' : 'इयत्ता पहिली'}</option>
                          <option value={language === 'English' ? 'Class II' : 'इयत्ता दुसरी'}> {language === 'English' ? ' Class II ' : 'इयत्ता दुसरी'}</option>
                          <option value={language === 'English' ? 'Class III' : 'इयत्ता तिसरी'}> {language === 'English' ? ' Class III ' : 'इयत्ता तिसरी'}</option>
                          <option value={language === 'English' ? 'Class IV' : 'इयत्ता चौथी'}> {language === 'English' ? ' Class IV ' : 'इयत्ता चौथी'}</option>
                          <option value={language === 'English' ? 'Class V' : 'इयत्ता पाचवी'}> {language === 'English' ? ' Class V ' : 'इयत्ता पाचवी'}</option>
                          <option value={language === 'English' ? 'Class VI' : 'इयत्ता सहावी'}> {language === 'English' ? ' Class VI ' : 'इयत्ता सहावी'}</option>
                          <option value={language === 'English' ? 'Class VII' : 'इयत्ता सातवी'}> {language === 'English' ? ' Class VII ' : 'इयत्ता सातवी'}</option>
                          <option value={language === 'English' ? 'Class VIII' : 'इयत्ता आठवी'}> {language === 'English' ? ' Class VIII ' : 'इयत्ता आठवी'}</option>
                          <option value={language === 'English' ? 'Class IX' : 'इयत्ता नववी'}> {language === 'English' ? ' Class IX ' : 'इयत्ता नववी'}</option>
                          <option value={language === 'English' ? 'Class X' : 'इयत्ता दहावी'}> {language === 'English' ? ' Class X ' : 'इयत्ता दहावी'}</option>
                          <option value={language === 'English' ? 'Class XI' : 'इयत्ता अकरावी'}> {language === 'English' ? ' Class XI ' : 'इयत्ता अकरावी'}</option>
                          <option value={language === 'English' ? 'Class XII' : 'इयत्ता बारावी'}> {language === 'English' ? ' class XII' : 'इयत्ता बारावी'}</option>

                          {(classes)
                            .filter(adclass =>
                              adclass !== (language === 'English' ? 'Class I' : 'इयत्ता पहिली') &&
                              adclass !== (language === 'English' ? 'Class II' : 'इयत्ता दुसरी') &&
                              adclass !== (language === 'English' ? 'Class III' : 'इयत्ता तिसरी') &&
                              adclass !== (language === 'English' ? 'Class IV' : 'इयत्ता चौथी') &&
                              adclass !== (language === 'English' ? 'Class V' : 'इयत्ता पाचवी') &&
                              adclass !== (language === 'English' ? 'Class VI' : 'इयत्ता सहावी') &&
                              adclass !== (language === 'English' ? 'Class VII' : 'इयत्ता सातवी') &&
                              adclass !== (language === 'English' ? 'Class VIII' : 'इयत्ता आठवी') &&
                              adclass !== (language === 'English' ? 'Class IX' : 'इयत्ता नववी') &&
                              adclass !== (language === 'English' ? 'Class X' : 'इयत्ता दहावी') &&
                              adclass !== (language === 'English' ? 'Class XI' : 'इयत्ता अकरावी') &&
                              adclass !== (language === 'English' ? 'Class XII' : 'इयत्ता बारावी')
                            )
                            .map((adclass, index) => (
                              <option key={index} value={adclass}>
                                {adclass}
                              </option>
                            ))
                          }
                          <option value="addNewAdmissionClass" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? '  Add New Class' : 'नवीन वर्ग जोडा'}
                          </option>
                        </select>
                      </div>
                    </div>

                    {showNewAdmissionClassForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newAdmissionClassInput">
                              {language === 'English' ? 'Enter new Admission Class: ' : 'नवीन प्रवेश वर्ग प्रविष्ट करा:'}
                            </label>
                            <input
                              type="text" className="newRegInput"
                              id="newAdmissionClassInput"
                              value={newAdmissionClass}
                              onChange={(e) =>
                                setNewAdmissionClass(e.target.value)
                              }
                            />

                            <button className="registerNewSaveBtn" onClick={handleNewAdmissionClassSubmit}>
                              {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                            </button>
                            <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                            {classes.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>  {language === 'English' ? 'Admission Class' : 'प्रवेश वर्ग'}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {classes.map((adclass, index) => (
                                      <tr key={index}>
                                        <td>{adclass}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Current Class' : 'सध्याचा वर्ग'}
                        </label>
                        <select
                          name="currentClass"
                          className='form-select' onFocus={() => handleFocus(13)}
                          ref={(el) => (inputs.current[13] = el)}
                          onChange={handleCurrentClassChange}
                          value={currentClass || admissionClass}
                        >
                          <option value="">  {language === 'English' ? 'Select Current Class' : 'सध्याचा वर्ग निवडा'}</option>
                          <option value={language === 'English' ? 'Class I' : 'इयत्ता पहिली'}> {language === 'English' ? ' Class I ' : 'इयत्ता पहिली'}</option>
                          <option value={language === 'English' ? 'Class II' : 'इयत्ता दुसरी'}> {language === 'English' ? ' Class II ' : 'इयत्ता दुसरी'}</option>
                          <option value={language === 'English' ? 'Class III' : 'इयत्ता तिसरी'}> {language === 'English' ? ' Class III ' : 'इयत्ता तिसरी'}</option>
                          <option value={language === 'English' ? 'Class IV' : 'इयत्ता चौथी'}> {language === 'English' ? ' Class IV ' : 'इयत्ता चौथी'}</option>
                          <option value={language === 'English' ? 'Class V' : 'इयत्ता पाचवी'}> {language === 'English' ? ' Class V ' : 'इयत्ता पाचवी'}</option>
                          <option value={language === 'English' ? 'Class VI' : 'इयत्ता सहावी'}> {language === 'English' ? ' Class VI ' : 'इयत्ता सहावी'}</option>
                          <option value={language === 'English' ? 'Class VII' : 'इयत्ता सातवी'}> {language === 'English' ? ' Class VII ' : 'इयत्ता सातवी'}</option>
                          <option value={language === 'English' ? 'Class VIII' : 'इयत्ता आठवी'}> {language === 'English' ? ' Class VIII ' : 'इयत्ता आठवी'}</option>
                          <option value={language === 'English' ? 'Class IX' : 'इयत्ता नववी'}> {language === 'English' ? ' Class IX ' : 'इयत्ता नववी'}</option>
                          <option value={language === 'English' ? 'Class X' : 'इयत्ता दहावी'}> {language === 'English' ? ' Class X ' : 'इयत्ता दहावी'}</option>
                          <option value={language === 'English' ? 'Class XI' : 'इयत्ता अकरावी'}> {language === 'English' ? ' Class XI ' : 'इयत्ता अकरावी'}</option>
                          <option value={language === 'English' ? 'Class XII' : 'इयत्ता बारावी'}> {language === 'English' ? ' class XII ' : 'इयत्ता बारावी'}</option>


                          {(classes)
                            .filter(adclass =>
                              adclass !== (language === 'English' ? 'Class I' : 'इयत्ता पहिली') &&
                              adclass !== (language === 'English' ? 'Class II' : 'इयत्ता दुसरी') &&
                              adclass !== (language === 'English' ? 'Class III' : 'इयत्ता तिसरी') &&
                              adclass !== (language === 'English' ? 'Class IV' : 'इयत्ता चौथी') &&
                              adclass !== (language === 'English' ? 'Class V' : 'इयत्ता पाचवी') &&
                              adclass !== (language === 'English' ? 'Class VI' : 'इयत्ता सहावी') &&
                              adclass !== (language === 'English' ? 'Class VII' : 'इयत्ता सातवी') &&
                              adclass !== (language === 'English' ? 'Class VIII' : 'इयत्ता आठवी') &&
                              adclass !== (language === 'English' ? 'Class IX' : 'इयत्ता नववी') &&
                              adclass !== (language === 'English' ? 'Class X' : 'इयत्ता दहावी') &&
                              adclass !== (language === 'English' ? 'Class XI' : 'इयत्ता अकरावी') &&
                              adclass !== (language === 'English' ? 'Class XII' : 'इयत्ता बारावी')
                            )
                            .map((adclass, index) => (
                              <option key={index} value={adclass}>
                                {adclass}
                              </option>
                            ))
                          }
                          <option value="addNewCurrentClass" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? 'Add New Class ' : 'नवीन वर्ग जोडा'}
                          </option>
                        </select>
                      </div>
                    </div>

                    {showNewCurrentClassForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newCurrentClassInput">
                              {language === 'English' ? 'Enter new Current Class:' : 'नवीन सध्याचा वर्ग प्रविष्ट करा:'}
                            </label>
                            <input
                              type="text" className="newRegInput"
                              id="newCurrentClassInput"
                              value={newCurrentClass}
                              onChange={(e) =>
                                setNewCurrentClass(e.target.value)
                              }
                            />

                            <button className="registerNewSaveBtn" onClick={handleNewCurrentClassSubmit}>
                              {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                            </button>
                            <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                            {classes.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th>  {language === 'English' ? 'Current Class' : 'सध्याचा वर्ग'}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {classes.map((adclass, index) => (
                                      <tr key={index}>
                                        <td>{adclass}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? ' Division' : 'तुकडी'}
                        </label>
                        <select
                          name="division"
                          className="form-select"
                          onChange={handleDivisionChange} onFocus={() => handleFocus(14)}
                          ref={(el) => (inputs.current[14] = el)}
                          value={division}
                        >
                          <option value="">  {language === 'English' ? '  division' : 'तुकडी निवडा'}</option>
                          {allDivisions.map((div, index) => (
                            <option key={index} value={div}>
                              {div}
                            </option>
                          ))}
                          <option value="addNewDivision" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? ' Add New division ' : 'नवीन तुकडी जोडा'}
                          </option>
                        </select>
                      </div>
                    </div>
                    {showNewDivisionForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newDivisionInput">
                              {language === 'English' ? 'Enter New Division:' : 'नवीन तुकडी प्रविष्ट करा:'}
                            </label>
                            <input
                              className="newRegInput"
                              type="text"
                              id="newDivisionInput"
                              value={newDivision}
                              onChange={(e) => setNewDivision(e.target.value)}
                            />
                            <button className="registerNewSaveBtn" onClick={handleNewDivisionSubmit}>
                              {language === 'English' ? (isEditingDivision ? 'Update' : 'Submit') : (isEditingDivision ? 'अपडेट करा' : 'प्रविष्ट करा')}
                            </button>
                            <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                            {allDivisions.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="text-center">{language === 'English' ? 'Division' : 'तुकडी'}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allDivisions.map((division, index) => (
                                      <tr key={index} onClick={() => handleRowClickDivision(index)}>
                                        <td>{division}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                      <div className="form-outline flex-fill mb-0">
                        <label
                          className="form-label"
                          htmlFor="form3Example1c"
                        >
                          {language === 'English' ? 'Date Of Admission ' : 'प्रवेशाची तारीख'}
                        </label>
                        <input
                          autoComplete="off"
                          type="date"
                          name="dateOfAdmission"
                          onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(25)}
                          ref={(el) => (inputs.current[25] = el)}
                          value={stdData.dateOfAdmission}
                          className="form-control" max={new Date().toISOString().split('T')[0]}
                        />
                      </div>
                    </div>

                    <style jsx>{`             
                    .tog-perdetail:hover {
    background-color: transparent;
    border: none;
    color: gray;
  }
                    `}</style>
                    <div onClick={togglePersonalDetails} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showPersonalDetails ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Student\'s Personal Details' : 'विद्यार्थ्यांची वैयक्तिक माहिती'}</span>
                    </div>

                    {showPersonalDetails && (
                      <>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Student\'s Name' : 'विद्यार्थी नाव'}

                            </label>
                            <input autoComplete="off"
                              type="text"
                              name="stdName"
                              onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(26)}
                              ref={(el) => (inputs.current[26] = el)}
                              value={stdData.stdName}
                              className={`form-control ${formSubmitted && stdData.stdName === "" ? "input-error" : ""}`}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Father\'s Name' : 'वडीलांचे नाव'}
                            </label>
                            <input
                              autoComplete="off"
                              type="text"
                              name="stdFather"
                              onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(27)}
                              ref={(el) => (inputs.current[27] = el)}
                              value={stdData.stdFather}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Surname' : 'आडनाव'}
                            </label>
                            <input
                              autoComplete="off" onFocus={() => handleFocus(28)}
                              ref={(el) => (inputs.current[28] = el)}
                              type="text"
                              value={stdData.stdSurname}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              className="form-control"
                              name="stdSurname"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Mother\'s Name' : 'आईचे नाव'}
                            </label>
                            <input
                              autoComplete="off"
                              type="text" onFocus={() => handleFocus(29)}
                              ref={(el) => (inputs.current[29] = el)}
                              name="stdMother"
                              value={stdData.stdMother}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              className="form-control"
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Aadhaar Card No' : 'आधार कार्ड क्र.'}
                            </label>
                            <input
                              autoComplete="off"
                              type="text"
                              name="stdAdharNo" onFocus={() => handleFocus(30)}
                              ref={(el) => (inputs.current[30] = el)}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              value={stdData.stdAdharNo}
                              maxLength={14}
                              className={`form-control ${formSubmitted && stdData.stdAdharNo === "" ? "input-error" : ""}`}
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0  mt-1">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Mobile No' : 'मोबाईल क्र'}
                            </label>
                            <input
                              autoComplete="off"
                              type="number"
                              name="mobileNo"
                              maxLength={10} onFocus={() => handleFocus(31)}
                              ref={(el) => (inputs.current[31] = el)}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              value={stdData.mobileNo}
                              className={`form-control ${formSubmitted && stdData.mobileNo === "" ? "input-error" : ""}`}
                            />
                          </div>
                        </div>



                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0  mt-1">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Email Id' : 'ईमेल आयडी'}
                            </label>
                            <input
                              autoComplete="off"
                              type="email"
                              name="stdemailId"
                              onFocus={() => handleFocus(32)}
                              ref={(el) => (inputs.current[32] = el)}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              value={stdData.stdemailId}
                              className={`form-control ${formSubmitted && stdData.stdemailId === "" ? "input-error" : ""}`}
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Date Of Birth' : 'जन्मतारीख'}
                            </label>
                            <input
                              autoComplete="off"
                              type="date"
                              name='dob'
                              value={stdData.dob} onFocus={() => handleFocus(33)}
                              ref={(el) => (inputs.current[33] = el)}
                              onChange={handleDOBChange} onKeyPress={handleEnterKey}
                              className='form-control' max={new Date().toISOString().split('T')[0]}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-8 col-xl-3">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example3c"
                            >
                              {language === 'English' ? 'Date Of Birth in words' : 'अक्षरी जन्मतारीख'}
                            </label>
                            <input
                              type="text"
                              value={stdData.dobInWords} onKeyPress={handleEnterKey}
                              readOnly
                              className="form-control"
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1">
                            <label className="form-label mt-2" >  {language === 'English' ? 'Gender' : 'लिंग'}</label>
                            <div className="">
                              <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                <input
                                  type="radio"
                                  name="gender"
                                  value="male"
                                  checked={gender === "male"}
                                  onChange={handleGenderChange} onFocus={() => handleFocus(34)}
                                  ref={(el) => (inputs.current[34] = el)}
                                  onKeyPress={handleEnterKey}
                                  className="form-check-input me-1"
                                />
                                {language === 'English' ? 'Male' : 'मुलगा'}</label>
                              <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                <input
                                  type="radio"
                                  name="gender"
                                  value="female"
                                  checked={gender === "female"} onFocus={() => handleFocus(35)} ref={(el) => (inputs.current[35] = el)}
                                  onChange={handleGenderChange} onKeyPress={handleEnterKey}
                                  className="form-check-input me-1"
                                />
                                {language === 'English' ? ' Female' : 'मुलगी'}

                              </label>
                            </div>
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Religion' : 'धर्म '}
                            </label>
                            <select
                              name="religion"
                              className="form-select"
                              onChange={handleReligionChange} onFocus={() => handleFocus(36)}
                              ref={(el) => (inputs.current[36] = el)}
                              value={religion}
                            >
                              <option value="">  {language === 'English' ? ' select religion' : 'धर्म निवडा'}</option>
                              <option value={language === 'English' ? 'Hindu' : 'हिंदू'}>
                                {language === 'English' ? 'Hindu' : 'हिंदू'}
                              </option>
                              <option value={language === 'English' ? 'Muslim' : ' मुस्लीम'}>
                                {language === 'English' ? 'Muslim' : ' मुस्लीम'}
                              </option>
                              <option value={language === 'English' ? 'Jain' : 'हिंदू'}>
                                {language === 'English' ? 'Jain' : 'जैन'}
                              </option>
                              <option value={language === 'English' ? 'Christians' : 'ख्रिश्चन'}>
                                {language === 'English' ? 'Christians' : 'ख्रिश्चन'}
                              </option>

                              {religions.filter(religion =>
                                religion !== 'Hindu' &&
                                religion !== 'हिंदू' &&
                                religion !== 'Muslim' &&
                                religion !== ' मुस्लीम' &&
                                religion !== 'Jain' &&
                                religion !== 'जैन' &&
                                religion !== 'Christians' &&
                                religion !== 'ख्रिश्चन '
                              ).map((religion, index) => (
                                <option key={index} value={religion}>
                                  {religion}
                                </option>
                              ))}
                              <option value="addNewRel" style={{ backgroundColor: '#B9B9B9' }}>
                                {language === 'English' ? ' Add New Religion ' : 'नवीन धर्म जोडा'}
                              </option>
                            </select>
                          </div>
                        </div>
                        {showNewReligionForm && (
                          <div className="overlay">
                            <div className="center-form">
                              <div className="new-book-form">
                                <label htmlFor="newReligionInput">
                                  {language === 'English' ? 'Enter New Religion:' : 'नवीन धर्म प्रविष्ट करा:'}
                                </label>
                                <input
                                  className="newRegInput"
                                  type="text"
                                  id="newReligionInput"
                                  value={newReligion}
                                  onChange={(e) => setNewReligion(e.target.value)}
                                />
                                <button className="registerNewSaveBtn" onClick={handleNewReligionSubmit}>
                                  {language === 'English' ? (isEditingReligion ? 'Update' : 'Submit') : (isEditingReligion ? 'अपडेट करा' : 'प्रविष्ट करा')}
                                </button>
                                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                                {religions.length > 0 && (
                                  <div className="book-list table-responsive">
                                    <table className="table table-striped">
                                      <thead>
                                        <tr>
                                          <th className="text-center">{language === 'English' ? 'Religion' : 'धर्म'}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {religions.map((religion, index) => (
                                          <tr key={index} onClick={() => handleRowClickReligion(index)}>
                                            <td>{religion}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}




                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 position-relative">
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="form3Example1c">
                              {language === 'English' ? ' Caste' : 'जात'}
                            </label>
                            <select
                              name="caste"
                              className="form-select" onFocus={() => handleFocus(37)}
                              ref={(el) => (inputs.current[37] = el)}
                              onChange={handleCasteChange}
                              value={caste}
                            >
                              <option value="">{language === 'English' ? 'select Caste' : 'जात निवडा'}</option>

                              <option value={language === 'English' ? 'Maratha' : 'मराठा'}>
                                {language === 'English' ? 'Maratha' : 'मराठा'}
                              </option>
                              <option value={language === 'English' ? 'Brahmin' : 'ब्राह्मण'}>
                                {language === 'English' ? 'Brahmin' : 'ब्राह्मण'}
                              </option>
                              <option value={language === 'English' ? 'Dhangar' : 'धनगर'}>
                                {language === 'English' ? 'Dhangar' : 'धनगर'}
                              </option>

                              {castes.filter(nat => nat !== 'Maratha' && nat !== 'मराठा' && nat !== 'Brahmin' && nat !== 'ब्राह्मण' && nat !== 'धनगर' && nat !== 'Dhangar').map((nat, index) => (
                                <option key={index} value={nat}>
                                  {nat}
                                </option>
                              ))}
                              <option value="addNewCaste" style={{ backgroundColor: '#B9B9B9' }}>
                                {language === 'English' ? ' Add New Caste ' : 'नवीन जात जोडा'}
                              </option>
                            </select>

                            {showNewCasteForm && (
                              <div className="overlay">
                                <div className="center-form">
                                  <div className="new-book-form">
                                    <label htmlFor="newCasteInput">
                                      {language === 'English' ? 'Enter New Caste:' : 'नवीन जात प्रविष्ट करा:'}
                                    </label>
                                    <input className="newRegInput" type="text" id="newCasteInput" value={newCaste} onChange={(e) => setNewCaste(e.target.value)} />
                                    <button className="registerNewSaveBtn" onClick={handleNewCasteSubmit}>
                                      {language === 'English' ? (isEditingCaste ? 'Update' : 'Submit') : (isEditingCaste ? 'अपडेट करा' : 'प्रविष्ट करा')}
                                    </button>
                                    <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                                    {castes.length > 0 && (
                                      <div className="book-list table-responsive">
                                        <table className="table table-striped">
                                          <thead>
                                            <tr>
                                              <th className="text-center">{language === 'English' ? 'Caste' : 'जात'}</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {castes.map((Caste, index) => (
                                              <tr key={index} onClick={() => handleRowClickCaste(index)}>
                                                <td>{Caste}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}


                            <button
                              className="open-minority-form-btn"
                              onClick={handleShowMinorityForm}
                            >
                              +
                            </button>
                            {showMinorityForm && (
                              <div className="modal1">
                                <div className="modal-content minority-form">
                                  <h4 className='my-2 mb-3'>
                                    {language === 'English' ? 'Enter Minority Information' : 'अल्पसंख्याक माहिती प्रविष्ट करा'}
                                  </h4>

                                  <label>{language === 'English' ? 'Category' : 'कॅटेगरी'}</label>
                                  <select
                                    value={casteCategory}
                                    onChange={handleCategoryChange}
                                    className="form-control mt-2"
                                  >
                                    <option value="">{language === 'English' ? 'Select Category' : 'कॅटेगरी निवडा'}</option>
                                    <option value="General">GEN</option>
                                    <option value="SC">SC</option>
                                    <option value="ST">ST</option>
                                    <option value="OBC">OBC</option>
                                    <option value="EWS">EWS</option>
                                    <option value="NT">NT</option>
                                    <option value="NTC">NTC</option>
                                    <option value="NTD">NTD</option>
                                    <option value="NTB ">NTB </option>
                                    <option value="SEBC ">SEBC </option>
                                    <option value="VJNT">VJNT</option>
                                    <option value="DNT">DNT</option>
                                    <option value="BC">BC</option>
                                    <option value="MBC">MBC</option>
                                    <option value="PWD">PWD </option>
                                    <option value="FC">FC</option>

                                    <option value="other">{language === 'English' ? 'Other' : 'इतर'}</option>

                                  </select>

                                  <label>
                                    <input
                                      type="checkbox"
                                      className="minoritycheck mt-3 mx-2"
                                      checked={isMinority}
                                      onChange={handleMinorityChange}
                                      style={{ width: 'auto' }}
                                    />
                                    {language === "English" ? 'Minority' : 'अल्पसंख्याक'}
                                  </label>

                                  <span className="close" onClick={handleCloseMinorityForm}>
                                    {language === "English" ? 'save and close' : 'जतन करा आणि बंद करा'}
                                  </span>
                                </div>
                              </div>
                            )}

                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? ' sub-caste' : 'पोटजात'}</label>
                            <input autoComplete="off" type="text" name="subCaste" maxLength='30' onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(38)}
                              ref={(el) => (inputs.current[38] = el)} value={stdData.subCaste} className="form-control" />
                          </div>
                        </div>




                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Nationality' : 'राष्ट्रीयत्व '}
                            </label>
                            <select
                              name="nationality"
                              className="form-select"
                              onChange={handleNationalityChange}
                              value={nationality} onFocus={() => handleFocus(39)}
                              ref={(el) => (inputs.current[39] = el)}
                            >
                              <option value="">{language === 'English' ? 'select Nationality' : 'राष्ट्रीयत्व निवडा'}</option>

                              <option value={language === 'English' ? 'Indian' : 'भारतीय'}>
                                {language === 'English' ? 'Indian' : 'भारतीय'}
                              </option>

                              {nationalities.filter(nat => nat !== 'Indian' && nat !== 'भारतीय').map((nat, index) => (
                                <option key={index} value={nat}>
                                  {nat}
                                </option>
                              ))}
                              <option value="addNewNat" style={{ backgroundColor: '#B9B9B9' }}>
                                {language === 'English' ? ' Add New Nationality ' : 'नवीन राष्ट्रीयत्व जोडा'}
                              </option>
                            </select>
                          </div>
                        </div>
                        {showNewNationalityForm && (
                          <div className="overlay">
                            <div className="center-form">
                              <div className="new-book-form">
                                <label htmlFor="newNationalityInput">
                                  {language === 'English' ? 'Enter New Nationality:' : 'नवीन राष्ट्रीयत्व प्रविष्ट करा:'}
                                </label>
                                <input
                                  className="newRegInput"
                                  type="text"
                                  id="newNationalityInput"
                                  value={newNationality}
                                  onChange={(e) => setNewNationality(e.target.value)}
                                />
                                <button className="registerNewSaveBtn" onClick={handleNewNationalitySubmit}>
                                  {language === 'English' ? (isEditingNationality ? 'Update' : 'Submit') : (isEditingNationality ? 'अपडेट करा' : 'प्रविष्ट करा')}
                                </button>
                                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                                {nationalities.length > 0 && (
                                  <div className="book-list table-responsive">
                                    <table className="table table-striped">
                                      <thead>
                                        <tr>
                                          <th className="text-center">{language === 'English' ? 'Nationality' : 'राष्ट्रीयत्व'}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {nationalities.map((nationality, index) => (
                                          <tr key={index} onClick={() => handleRowClickNationality(index)}>
                                            <td>{nationality}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Mother Tounge' : 'मातृभाषा '}
                            </label>
                            <select
                              name="MotherTounge"
                              className="form-select"
                              onChange={handleMotherToungeChange} onFocus={() => handleFocus(40)}
                              ref={(el) => (inputs.current[40] = el)}
                              value={motherTounge}
                            >
                              <option value="">{language === 'English' ? 'select Mother Tounge' : 'मातृभाषा निवडा'}</option>

                              <option value={language === 'English' ? 'Marathi' : 'मराठी'}>
                                {language === 'English' ? 'Marathi' : 'मराठी'}
                              </option>

                              {motherTounges.filter(nat => nat !== 'Marathi' && nat !== 'मराठी').map((nat, index) => (
                                <option key={index} value={nat}>
                                  {nat}
                                </option>
                              ))}
                              <option value="addNewMotherTounge" style={{ backgroundColor: '#B9B9B9' }}>
                                {language === 'English' ? ' Add New Mother Tounge ' : 'नवीन मातृभाषा जोडा'}
                              </option>
                            </select>
                          </div>
                        </div>
                        {showNewMotherToungeForm && (
                          <div className="overlay">
                            <div className="center-form">
                              <div className="new-book-form">
                                <label htmlFor="newMotherToungeInput">
                                  {language === 'English' ? 'Enter New Mother Tounge:' : 'नवीन मातृभाषा प्रविष्ट करा:'}
                                </label>
                                <input className="newRegInput" type="text" id="newMotherToungeInput" value={newMotherTounge} onChange={(e) => setNewMotherTounge(e.target.value)} />
                                <button className="registerNewSaveBtn" onClick={handleNewMotherToungeSubmit}>
                                  {language === 'English' ? (isEditingMotherTounge ? 'Update' : 'Submit') : (isEditingMotherTounge ? 'अपडेट करा' : 'प्रविष्ट करा')}
                                </button>
                                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                                {motherTounges.length > 0 && (
                                  <div className="book-list table-responsive">
                                    <table className="table table-striped">
                                      <thead>
                                        <tr>
                                          <th className="text-center">{language === 'English' ? 'Mother Tounge' : 'मातृभाषा'}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {motherTounges.map((MotherTounge, index) => (
                                          <tr key={index} onClick={() => handleRowClickMotherTounge(index)}>
                                            <td>{MotherTounge}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Birth Place' : 'जन्मस्थान'}
                            </label>
                            <input autoComplete="off" type="text" name="birthPlace" onChange={handleTextChange} onKeyPress={handleEnterKey} value={stdData.birthPlace} onFocus={() => handleFocus(41)}
                              ref={(el) => (inputs.current[41] = el)} className="form-control" />
                          </div>
                        </div>
                      </>
                    )}

                    <div onClick={toggleAddressDetails} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showAddressDetails ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Address Details' : 'पत्ता माहिती'}</span>
                    </div>
                    {showAddressDetails && (
                      <>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'City' : 'शहर'}
                            </label>
                            <input autoComplete="off" type="text" name="city" onChange={handleTextChange} onKeyPress={handleEnterKey} value={stdData.city} onFocus={() => handleFocus(101)}
                              ref={(el) => (inputs.current[101] = el)} className="form-control" />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Address' : 'पत्ता'}
                            </label>
                            <input autoComplete="off" type="text" name="address" onChange={handleTextChange} onKeyPress={handleEnterKey} value={stdData.address} onFocus={() => handleFocus(42)}
                              ref={(el) => (inputs.current[42] = el)} className="form-control" maxLength="60" />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? ' Country' : 'देश '}
                            </label>
                            <select name="country" className="form-select" onChange={handleCountryChange} onFocus={() => handleFocus(43)}
                              ref={(el) => (inputs.current[43] = el)} value={country}>
                              <option value="">{language === 'English' ? 'select Country' : 'देश निवडा'}</option>
                              <option value={language === 'English' ? 'India' : 'भारत'}>
                                {language === 'English' ? 'India' : 'भारत'}
                              </option>

                            </select>
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'State' : 'राज्य '}
                            </label>
                            <select
                              name="state" onFocus={() => handleFocus(44)}
                              ref={(el) => (inputs.current[44] = el)}
                              className='form-select'
                              onChange={handleStateChange}
                              value={state}
                            >
                              <option value="">{language === 'English' ? 'select state' : 'राज्य निवडा'}</option>
                              <option value={language === 'English' ? 'Andhra Pradesh' : 'आंध्र प्रदेश'}>{language === 'English' ? 'Andhra Pradesh' : 'आंध्र प्रदेश'}</option>
                              <option value={language === 'English' ? 'Arunachal Pradesh' : 'अरुणाचल प्रदेश'}>{language === 'English' ? 'Arunachal Pradesh' : 'अरुणाचल प्रदेश'}</option>
                              <option value={language === 'English' ? 'Assam' : 'असम'}>{language === 'English' ? 'Assam' : 'असम'}</option>
                              <option value={language === 'English' ? 'Bihar' : 'बिहार'}>{language === 'English' ? 'Bihar' : 'बिहार'}</option>
                              <option value={language === 'English' ? 'Chhattisgarh' : 'छत्तीसगढ़'}>{language === 'English' ? 'Chhattisgarh' : 'छत्तीसगढ़'}</option>
                              <option value={language === 'English' ? 'Goa' : 'गोवा'}>{language === 'English' ? 'Goa' : 'गोवा'}</option>
                              <option value={language === 'English' ? 'Gujarat' : 'गुजरात'}>{language === 'English' ? 'Gujarat' : 'गुजरात'}</option>
                              <option value={language === 'English' ? 'Haryana' : 'हरियाणा'}>{language === 'English' ? 'Haryana' : 'हरियाणा'}</option>
                              <option value={language === 'English' ? 'Himachal Pradesh' : 'हिमाचल प्रदेश'}>{language === 'English' ? 'Himachal Pradesh' : 'हिमाचल प्रदेश'}</option>
                              <option value={language === 'English' ? 'Jharkhand' : 'झारखंड'}>{language === 'English' ? 'Jharkhand' : 'झारखंड'}</option>
                              <option value={language === 'English' ? 'Karnataka' : 'कर्नाटक'}>{language === 'English' ? 'Karnataka' : 'कर्नाटक'}</option>
                              <option value={language === 'English' ? 'Kerala' : 'केरल'}>{language === 'English' ? 'Kerala' : 'केरल'}</option>
                              <option value={language === 'English' ? 'Madhya Pradesh' : 'मध्य प्रदेश'}>{language === 'English' ? 'Madhya Pradesh' : 'मध्य प्रदेश'}</option>
                              <option value={language === 'English' ? 'Maharashtra' : 'महाराष्ट्र'}>{language === 'English' ? 'Maharashtra' : 'महाराष्ट्र'}</option>
                              <option value={language === 'English' ? 'Manipur' : 'मणिपुर'}>{language === 'English' ? 'Manipur' : 'मणिपुर'}</option>
                              <option value={language === 'English' ? 'Meghalaya' : 'मेघालय'}>{language === 'English' ? 'Meghalaya' : 'मेघालय'}</option>
                              <option value={language === 'English' ? 'Mizoram' : 'मिजोरम'}>{language === 'English' ? 'Mizoram' : 'मिजोरम'}</option>
                              <option value={language === 'English' ? 'Nagaland' : 'नागालैंड'}>{language === 'English' ? 'Nagaland' : 'नागालैंड'}</option>
                              <option value={language === 'English' ? 'Odisha' : 'उड़ीसा'}>{language === 'English' ? 'Odisha' : 'उड़ीसा'}</option>
                              <option value={language === 'English' ? 'Punjab' : 'पंजाब'}>{language === 'English' ? 'Punjab' : 'पंजाब'}</option>
                              <option value={language === 'English' ? 'Rajasthan' : 'राजस्थान'}>{language === 'English' ? 'Rajasthan' : 'राजस्थान'}</option>
                              <option value={language === 'English' ? 'Sikkim' : 'सिक्किम'}>{language === 'English' ? 'Sikkim' : 'सिक्किम'}</option>
                              <option value={language === 'English' ? 'Tamil Nadu' : 'तमिलनाडु'}>{language === 'English' ? 'Tamil Nadu' : 'तमिलनाडु'}</option>
                              <option value={language === 'English' ? 'Telangana' : 'तेलंगाना'}>{language === 'English' ? 'Telangana' : 'तेलंगाना'}</option>
                              <option value={language === 'English' ? 'Tripura' : 'त्रिपुरा'}>{language === 'English' ? 'Tripura' : 'त्रिपुरा'}</option>
                              <option value={language === 'English' ? 'Uttar Pradesh' : 'उत्तर प्रदेश'}>{language === 'English' ? 'Uttar Pradesh' : 'उत्तर प्रदेश'}</option>
                              <option value={language === 'English' ? 'Uttarakhand' : 'उत्तराखंड'}>{language === 'English' ? 'Uttarakhand' : 'उत्तराखंड'}</option>
                              <option value={language === 'English' ? 'West Bengal' : 'पश्चिम बंगाल'}>{language === 'English' ? 'West Bengal' : 'पश्चिम बंगाल'}</option>
                              <option value={language === 'English' ? 'Andaman and Nicobar Islands' : 'अंडमान और निकोबार द्वीप समूह'}>{language === 'English' ? 'Andaman and Nicobar Islands' : 'अंडमान और निकोबार द्वीप समूह'}</option>
                              <option value={language === 'English' ? 'Chandigarh' : 'चंडीगढ़'}>{language === 'English' ? 'Chandigarh' : 'चंडीगढ़'}</option>
                              <option value={language === 'English' ? 'Dadra and Nagar Haveli and Daman and Diu' : 'दादरा और नगर हवेली और दमन और दीव'}>{language === 'English' ? 'Dadra and Nagar Haveli and Daman and Diu' : 'दादरा और नगर हवेली और दमन और दीव'}</option>
                              <option value={language === 'English' ? 'Delhi' : 'दिल्ली'}>{language === 'English' ? 'Delhi' : 'दिल्ली'}</option>
                              <option value={language === 'English' ? 'Lakshadweep' : 'लक्षद्वीप'}>{language === 'English' ? 'Lakshadweep' : 'लक्षद्वीप'}</option>
                              <option value={language === 'English' ? 'Puducherry' : 'पुदुच्चेरी'}>{language === 'English' ? 'Puducherry' : 'पुदुच्चेरी'}</option>
                              {states.map((st, index) => (
                                <option key={index} value={st}>
                                  {st}
                                </option>
                              ))}
                              {/* <option value="addNewState" style={{ backgroundColor: '#B9B9B9' }}>
                            {language === 'English' ? ' Add New State' : 'नवीन राज्य जोडा'}
                          </option> */}
                            </select>
                          </div>
                        </div>
                        {/* {showNewStateForm && (
                      <div className="overlay">
                        <div className="center-form">
                          <div className="new-book-form">
                            <label htmlFor="newStateInput">
                              {language === 'English' ? ' Enter New State: ' : 'नवीन राज्य प्रविष्ट करा:'}
                            </label>
                            <input className="newRegInput"
                              type="text"
                              id="newStateInput"
                              value={newState}
                              onChange={(e) =>
                                setNewState(e.target.value)
                              }
                            /><button className="registerNewSaveBtn" onClick={handleNewStateSubmit}>
                              {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                            </button>
                            <button className="registerNewCloseBtn" onClick={
                              closeButtonClick
                            }
                            ><CloseIcon /></button>

                            {states.length > 0 && (
                              <div className="book-list table-responsive">
                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th> {language === 'English' ? ' State' : 'राज्य'}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {states.map((state, index) => (
                                      <tr key={index}>
                                        <td>{state}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )} */}

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="districtSelect">{language === 'English' ? ' District' : 'जिल्हा'}</label>
                            {/* <select id="districtSelect"  onFocus={() => handleFocus(45)}
                          ref={(el) => (inputs.current[45] = el)} className={`form-select ${formSubmitted && selectedDistrict === "" ? "input-error" : ""}`} value={selectedDistrict} onChange={handleDistrictChange}>
                          <option value="">  {language === 'English' ? ' Select District' : 'जिल्हा निवडा'}</option>
                          {districtsData.Maharashtra.map((district, index) => (
                            <option key={index} value={district}>{district}</option>
                          ))}
                        </select> */}
                            {districts && districts.length > 0 ? (
                              <select
                                id="districtSelect"
                                className={`form-select ${formSubmitted && selectedDistrict === "" ? "input-error" : ""}`}
                                onChange={handleDistrictChange}
                                value={selectedDistrict}
                                onFocus={() => handleFocus(45)}
                                ref={(el) => (inputs.current[45] = el)}
                              >
                                <option value="">{language === 'English' ? 'Select District' : 'जिल्हा निवडा'}</option>
                                {districts.map((district, index) => (
                                  <option key={index} value={district}>{district}</option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type="text"
                                id="districtSelect"
                                className={`form-control ${formSubmitted && selectedDistrict === "" ? "input-error" : ""}`}
                                onChange={handleDistrictChange}
                                value={selectedDistrict}
                                onFocus={() => handleFocus(45)}
                                ref={(el) => (inputs.current[45] = el)}
                                placeholder={language === 'English' ? 'Enter District' : 'जिल्हा प्रविष्ट करा'}
                                autoComplete="off"
                              />
                            )}

                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="talukaSelect">{language === 'English' ? 'Taluka' : 'तालुका'}</label>
                            {/* <select id="talukaSelect"  onFocus={() => handleFocus(46)}
                          ref={(el) => (inputs.current[46] = el)} className={`form-select ${formSubmitted && selectedTaluka === "" ? "input-error" : ""}`} value={selectedTaluka} onChange={handleTalukaChange}>
                          <option value="">  {language === 'English' ? ' Select Taluka' : 'तालुका निवडा'}</option>
                          {talukaOptions}
                        </select> */}
                            {selectedDistrict && talukas && talukas[selectedDistrict] && talukas[selectedDistrict].length > 0 ? (
                              <select
                                id="talukaSelect"
                                className={`form-select ${formSubmitted && selectedTaluka === "" ? "input-error" : ""}`}
                                onChange={handleTalukaChange}
                                value={selectedTaluka}
                                onFocus={() => handleFocus(46)}
                                ref={(el) => (inputs.current[46] = el)}
                              >
                                <option value="">{language === 'English' ? 'Select Taluka' : 'तालुका निवडा'}</option>
                                {talukas[selectedDistrict].map((taluka, index) => (
                                  <option key={index} value={taluka}>{taluka}</option>
                                ))}
                              </select>
                            ) : (
                              <input
                                type="text"
                                id="talukaSelect"
                                className={`form-control ${formSubmitted && selectedTaluka === "" ? "input-error" : ""}`}
                                onChange={handleTalukaChange}
                                value={selectedTaluka}
                                onFocus={() => handleFocus(46)}
                                ref={(el) => (inputs.current[46] = el)}
                                placeholder={language === 'English' ? 'Enter Taluka' : 'तालुका प्रविष्ट करा'}
                                autoComplete="off"
                              />
                            )}

                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Pincode' : 'पिनकोड'}
                            </label>
                            <input autoComplete="off" type="number" name="pincode" onChange={handleTextChange} onKeyPress={handleEnterKey} value={stdData.pincode} onFocus={() => handleFocus(47)}
                              ref={(el) => (inputs.current[47] = el)} className="form-control" maxLength="6" />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Approx. distance of student residence to school (kms)' : 'अंदाजे शाळेपासून विद्यार्थ्यांच्या निवासाचे अंतर (किमी)'}
                            </label>
                            <input autoComplete="off" type="text" name="distance" onChange={handleTextChange} onKeyPress={handleEnterKey} value={stdData.distance} onFocus={() => handleFocus(48)}
                              ref={(el) => (inputs.current[48] = el)} className="form-control" />
                          </div>
                        </div>

                      </>)}


                    <div onClick={togglePreviousSchoolDetails} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showPreviousSchoolDetails ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Previous School Details' : 'मागील शाळेची माहिती'}</span>
                    </div>


                    {showPreviousSchoolDetails && (<>
                      <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 " ref={prevSchoolDropdownRef}>
                        <div className="form-outline flex-fill mb-0 position-relative">
                          <label
                            className="form-label"
                            htmlFor="form3Example1c"
                          >
                            {language === 'English' ? 'Previous School' : 'या पूर्वीची शाळा '}
                          </label>
                          <button
                            type="button"
                            name="prevSchool"
                            className="form-select text-start"
                            onClick={() => {
                              setIsOpenPrevSchoolDropdown(!isOpenPrevSchoolDropdown);
                              setSearchPrevSchoolQuery("");
                            }}
                            ref={(el) => (inputs.current[49] = el)}
                            style={{
                              background: '#fff',
                              color: prevSchool ? '#212529' : '#6c757d',
                              fontWeight: 'normal',
                              boxShadow: 'none',
                              width: '100%'
                            }}
                          >
                            {prevSchool || (language === 'English' ? 'Select School' : 'शाळा निवडा')}
                          </button>

                          {isOpenPrevSchoolDropdown && (
                            <div
                              className="custom-dropdown-menu"
                              style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                zIndex: 1050,
                                background: '#fff',
                                border: '1px solid #ced4da',
                                borderRadius: '0.375rem',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                marginTop: '4px',
                                maxHeight: '250px',
                                display: 'flex',
                                flexDirection: 'column'
                              }}
                            >
                              <div style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                                <input
                                  type="text"
                                  placeholder={language === 'English' ? 'Search school...' : 'शाळा शोधा...'}
                                  value={searchPrevSchoolQuery}
                                  onChange={(e) => setSearchPrevSchoolQuery(e.target.value)}
                                  autoFocus
                                  style={{
                                    width: '100%',
                                    padding: '6px 10px',
                                    border: '1px solid #ced4da',
                                    borderRadius: '4px',
                                    outline: 'none',
                                    fontSize: '14px'
                                  }}
                                />
                              </div>
                              <div style={{ overflowY: 'auto', flex: 1 }}>
                                {filteredSchools.length > 0 ? (
                                  filteredSchools.map((schoolOption, index) => (
                                    <div
                                      key={index}
                                      onClick={() => {
                                        setPrevSchool(schoolOption);
                                        setStdData(prevData => ({
                                          ...prevData,
                                          prevSchool: schoolOption
                                        }));
                                        setIsOpenPrevSchoolDropdown(false);
                                      }}
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #f1f1f1',
                                        color: '#333',
                                        fontSize: '14px',
                                        transition: 'background-color 0.2s'
                                      }}
                                      className="custom-dropdown-item"
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#0d6efd';
                                        e.target.style.color = '#fff';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = '#333';
                                      }}
                                    >
                                      {schoolOption}
                                    </div>
                                  ))
                                ) : (
                                  <div style={{ padding: '8px 12px', color: '#6c757d', fontStyle: 'italic', fontSize: '14px' }}>
                                    {language === 'English' ? 'No schools found' : 'कोणतीही शाळा आढळली नाही'}
                                  </div>
                                )}
                                <div
                                  onClick={() => {
                                    setShowNewPrevSchoolForm(true);
                                    setIsOpenPrevSchoolDropdown(false);
                                  }}
                                  style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    backgroundColor: '#B9B9B9',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    textAlign: 'center',
                                    borderTop: '1px solid #ccc',
                                    fontSize: '14px'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#a3a3a3';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#B9B9B9';
                                  }}
                                >
                                  {language === 'English' ? '+ Add New School' : '+ नवीन शाळा जोडा'}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {showNewPrevSchoolForm && (
                        <div className="overlay">
                          <div className="center-form">
                            <div className="new-book-form">
                              <label htmlFor="newprevSchoolInput">
                                {language === 'English' ? 'Enter New School:' : 'नवीन शाळा प्रविष्ट करा:'}
                              </label>
                              <input
                                className="newRegInput"
                                type="text"
                                id="newprevSchoolInput"
                                value={newPrevSchool}
                                onChange={(e) => setNewPrevSchool(e.target.value)}
                              />
                              <button className="registerNewSaveBtn" onClick={handleNewPrevSchoolSubmit}>
                                {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                              </button>
                              <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                              {prevSchools.length > 0 && (
                                <div className="book-list table-responsive">
                                  <table className="table table-striped">
                                    <thead>
                                      <tr>
                                        <th className="text-center">{language === 'English' ? 'School' : 'शाळा'}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {prevSchools.map((school, index) => (
                                        <tr key={index} onClick={() => handleRowClickPrevSchool(index)}>
                                          <td>{school}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                        <div className="form-outline flex-fill mb-0">
                          <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? 'Previous School Leaving Certificate Date' : 'मागील शाळा सोडल्याच्या दाखल्याची तारीख'}</label>

                          <input
                            autoComplete="off"
                            type="date"
                            name='prevLCDate'
                            value={stdData.prevLCDate} onFocus={() => handleFocus(50)}
                            ref={(el) => (inputs.current[50] = el)}
                            onChange={handleprevLCDateChange} onKeyPress={handleEnterKey}
                            className='form-control'
                          />


                        </div>
                      </div>

                      <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                        <div className="form-outline flex-fill mb-0">
                          <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? 'Previous Class' : 'मागील इयत्ता'}</label>
                          <input autoComplete="off" type="text" name="prevClass" maxLength='30' onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(51)}
                            ref={(el) => (inputs.current[51] = el)} value={stdData.prevClass} className="form-control" />
                        </div>
                      </div>
                      <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                        <div className="form-outline flex-fill mb-0">
                          <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? ' Previous Year Percentage' : 'मागील वर्षाची टक्केवारी'}</label>
                          <input autoComplete="off" type="text" name="prevPercent" maxLength='30' onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(51)}
                            ref={(el) => (inputs.current[51] = el)} value={stdData.prevPercent} className="form-control" />
                        </div>
                      </div>
                      <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                        <div className="form-outline flex-fill mb-0">
                          <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? ' Previous Year Marks' : 'मागील वर्षाचे गुण'}</label>
                          <input autoComplete="off" type="text" name="prevMarks" maxLength='30' onChange={handleTextChange} onKeyPress={handleEnterKey} onFocus={() => handleFocus(52)}
                            ref={(el) => (inputs.current[52] = el)} value={stdData.prevMarks} className="form-control" />
                        </div>
                      </div>
                    </>)}



                    <div onClick={toggleOtherDetails} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showOtherDetails ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Other Details' : 'इतर माहिती'}</span>
                    </div>

                    <style jsx>{` 
  /* Container Styling */
.student-register-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  min-height: 100vh;
  font-family: 'Roboto', sans-serif;
}
.

/* Card Styling */
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 25px;
  margin: 0 auto;
  max-width: 1300px;
  border: 1px solid #e0e4e8;
}

/* Form Elements */
.form-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.form-control, .form-select {
  border-radius: 8px;
  border: 1px solid #d1d9e6;
  padding: 10px;
  font-size: 14px;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-control:focus, .form-select:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.3);
  outline: none;
}

/* Buttons */
.btn {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-primary {
  background-color: #2980b9;
  border: none;
}

.btn-primary:hover {
  background-color: #3498db;
  transform: translateY(-2px);
}

.btn-danger {
  background-color: #e74c3c;
}

.btn-danger:hover {
  background-color: #c0392b;
}

/* Section Headers */
.section-header {
  border-bottom: 2px solid #ecf0f1;
  padding-bottom: 10px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #34495e;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Toggle Button */
.tog-perdetail {
  background: none;
  border: none;
  font-size: 20px;
  color: #7f8c8d;
  cursor: pointer;
}

/* Popup Styling */
.popup-overlay {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
}

.popup-content {
  border-radius: 12px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .card {
    padding: 15px;
  }
  .btn {
    width: 100%;
    margin-bottom: 10px;
  }
}
`}</style>


                    {showOtherDetails && (
                      <>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0  mt-1">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Aadhaar Linked Mobile No' : 'आधार लिंक केलेला मोबाईल क्र'}
                            </label>
                            <input
                              autoComplete="off"
                              type="number"
                              name="adharmobileNo"
                              maxLength={10} onFocus={() => handleFocus(53)}
                              ref={(el) => (inputs.current[53] = el)}
                              onChange={handleTextChange} onKeyPress={handleEnterKey}
                              value={stdData.adharmobileNo}
                              className={`form-control ${formSubmitted && stdData.adharmobileNo === "" ? "input-error" : ""}`}
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label className="form-label" htmlFor="form3Example1c"> {language === 'English' ? ' Birthmark' : 'जन्मखूण'}</label>

                            <input
                              type="text"
                              name="birthmark"
                              onChange={handleTextChange}
                              value={stdData.birthmark} onFocus={() => handleFocus(54)} ref={(el) => (inputs.current[54] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1">
                            <label className="form-label mt-3">
                              {language === 'English' ? 'Physically challenged (CWSN)?' : 'शारीरिकदृष्ट्या विकलांग (CWSN)?'}
                              <div style={{ paddingTop: '10px' }}>
                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isCWSN"
                                    value="true"
                                    checked={isCWSN === "true"}
                                    onChange={handleCWSNChange} onFocus={() => handleFocus(55)}
                                    ref={(el) => (inputs.current[55] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isCWSN"
                                    value="false"
                                    checked={isCWSN === "false"} onFocus={() => handleFocus(56)} ref={(el) => (inputs.current[56] = el)}
                                    onChange={handleCWSNChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}
                                </label>

                              </div>
                            </label>
                          </div>
                        </div>
                        {isCWSN === "true" && (
                          <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                            <div className="form-outline flex-fill mb-0">
                              <label
                                className="form-label"
                                htmlFor="form3Example1c"
                              >
                                {language === 'English' ? 'Category of Disability' : 'अपंगत्वाची श्रेणी'}
                              </label>

                              <input
                                type="text" autoComplete="off"
                                className="form-control"
                                placeholder={language === 'English' ? 'Enter Category of Disability ' : 'अपंगत्वाची श्रेणी प्रविष्ट करा'}
                                value={stdData.disabilityName} onKeyPress={handleEnterKey} onFocus={() => handleFocus(57)}
                                ref={(el) => (inputs.current[57] = el)}
                                onChange={(e) => setStdData((prevData) => ({ ...prevData, disabilityName: e.target.value }))}
                              />
                            </div>
                          </div>
                        )}




                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              ELGA
                            </label>
                            <select
                              name="ELGA"
                              className={`form-select ${formSubmitted && ELGA === "" ? "input-error" : ""}`} onFocus={() => handleFocus(58)}
                              ref={(el) => (inputs.current[58] = el)}
                              onChange={handleELGAChange}
                              value={ELGA} // This should reflect the state
                            >
                              <option value="">{language === 'English' ? 'Select ELGA Level' : 'ELGA Level निवडा'}</option>
                              {[...new Set(ELGAs)].map((ELGA, index) => (
                                <option key={index} value={ELGA}>
                                  {ELGA}
                                </option>
                              ))}

                              <option value="addNewELGA" style={{ backgroundColor: '#B9B9B9' }}>
                                {language === 'English' ? 'Add New ELGA Level ' : 'नवीन ELGA Level निवडा '}
                              </option>
                            </select>
                          </div>
                        </div>
                        {showNewELGAForm && (
                          <div className="overlay">
                            <div className="center-form">
                              <div className="new-book-form">
                                <label htmlFor="newELGAInput">
                                  {language === 'English' ? ' Enter New ELGA Level: ' : 'नवीन ELGA  निवडा:'}

                                </label>
                                <input
                                  type="text"
                                  className="newRegInput"
                                  id="newELGAInput"
                                  value={newELGA}
                                  onChange={(e) =>
                                    setNewELGA(e.target.value)
                                  }
                                />
                                <button className="registerNewSaveBtn"
                                  onClick={handleNewELGASubmit}
                                >
                                  {language === 'English' ? 'Submit' : 'प्रविष्ट करा'}
                                </button>
                                <button className="registerNewCloseBtn" onClick={closeButtonClick}><CloseIcon /></button>
                                {ELGAs.length > 0 && (
                                  <div className="book-list table-responsive">
                                    <table className="table table-striped">
                                      <thead>
                                        <tr>
                                          <th>  {language === 'English' ? 'ELGA Level' : 'ELGA Level'}</th>

                                        </tr>
                                      </thead>
                                      <tbody>
                                        {ELGAs.map(
                                          (ELGA, index) => (
                                            <tr key={index}>
                                              <td>{ELGA}</td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1">
                            <label className="form-label mt-3">

                              {language === 'English' ? 'RTE Admission' : 'RTE प्रवेश'}
                              <div style={{ paddingTop: '10px' }}>

                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isRTE"
                                    value="true"
                                    checked={isRTE === "true"}
                                    onChange={handleRTEChange} onFocus={() => handleFocus(59)}
                                    ref={(el) => (inputs.current[59] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isRTE"
                                    value="false"
                                    checked={isRTE === "false"} onFocus={() => handleFocus(60)} ref={(el) => (inputs.current[60] = el)}
                                    onChange={handleRTEChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}

                                </label>
                              </div>
                            </label>

                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Blood Group' : 'रक्त गट'}
                            </label>
                            <select
                              name="bloodGroup"
                              className="form-select"
                              onChange={handleTextChange}
                              value={stdData.bloodGroup} onFocus={() => handleFocus(61)} ref={(el) => (inputs.current[61] = el)}
                            >
                              <option value=""> {language === 'English' ? 'Select Blood Group' : 'रक्त गट निवडा'}</option>
                              <option value="A+">A+</option>
                              <option value="A-">A-</option>
                              <option value="B+">B+</option>
                              <option value="B-">B-</option>
                              <option value="AB+">AB+</option>
                              <option value="AB-">AB-</option>
                              <option value="O+">O+</option>
                              <option value="O-">O-</option>
                            </select>
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1 mt-2" style={{ fontWeight: 'normal' }}>
                            <label className="form-label mt-3">

                              {language === 'English' ? 'BPL Beneficiary (Ration card)?' : 'BPL लाभार्थी (Ration card)?'}
                              <div style={{ paddingTop: '10px' }}>

                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isBPL"
                                    value="true"
                                    checked={isBPL === "true"}
                                    onChange={handleBPLChange} onFocus={() => handleFocus(62)}
                                    ref={(el) => (inputs.current[62] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isBPL"
                                    value="false"
                                    checked={isBPL === "false"} onFocus={() => handleFocus(63)} ref={(el) => (inputs.current[63] = el)}
                                    onChange={handleBPLChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}
                                </label>
                              </div>
                            </label>
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1 mt-2">
                            <label className="form-label mt-3">

                              {language === 'English' ? ' AAY Beneficiary' : 'AAY लाभार्थी'}
                              <div style={{ paddingTop: '10px' }}>

                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isAAY"
                                    value="true"
                                    checked={isAAY === "true"}
                                    onChange={handleAAYChange} onFocus={() => handleFocus(64)}
                                    ref={(el) => (inputs.current[64] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isAAY"
                                    value="false"
                                    checked={isAAY === "false"} onFocus={() => handleFocus(65)} ref={(el) => (inputs.current[65] = el)}
                                    onChange={handleAAYChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}

                                </label>
                              </div>
                            </label>

                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1 mt-2">
                            <label className="form-label mt-3">

                              {language === 'English' ? 'Boarder/Resident Student?' : 'बोर्डर/निवासी विद्यार्थी? '}
                              <div style={{ paddingTop: '10px' }}>

                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isHosteller"
                                    value="true"
                                    checked={isHosteller === "true"}
                                    onChange={handleHostellerChange} onFocus={() => handleFocus(66)}
                                    ref={(el) => (inputs.current[66] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isHosteller"
                                    value="false"
                                    checked={isHosteller === "false"} onFocus={() => handleFocus(67)} ref={(el) => (inputs.current[67] = el)}
                                    onChange={handleHostellerChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}
                                </label>
                              </div>
                            </label>
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1 mt-2">
                            <label className="form-label mt-3">
                              {language === 'English' ? 'Scholarship?' : 'शिष्यवृत्ती?'}
                              <div style={{ paddingTop: '10px' }}>
                                <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isScolar"
                                    value="true"
                                    checked={isScolar === "true"}
                                    onChange={handleScolarChange} onFocus={() => handleFocus(68)}
                                    ref={(el) => (inputs.current[68] = el)}
                                    onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? 'Yes' : 'होय'}</label>
                                <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                  <input
                                    type="radio"
                                    name="isScolar"
                                    value="false"
                                    checked={isScolar === "false"} onFocus={() => handleFocus(69)} ref={(el) => (inputs.current[69] = el)}
                                    onChange={handleScolarChange} onKeyPress={handleEnterKey}
                                    className="form-check-input me-1"
                                  />
                                  {language === 'English' ? ' No' : 'नाही'}
                                </label>

                              </div>
                            </label>
                          </div>
                        </div>
                        {isScolar === "true" && (
                          <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                            <div className="form-outline flex-fill mb-0">
                              <label
                                className="form-label"
                                htmlFor="form3Example1c"
                              >
                                {language === 'English' ? 'Enter Scholarship ' : 'शिष्यवृत्ती  प्रविष्ट करा'}

                              </label>

                              <input
                                type="text" autoComplete="off"
                                className="form-control"
                                placeholder={language === 'English' ? 'Enter Scholarship ' : 'शिष्यवृत्ती  प्रविष्ट करा'}
                                value={stdData.scolarName} onKeyPress={handleEnterKey} onFocus={() => handleFocus(70)}
                                ref={(el) => (inputs.current[70] = el)}
                                onChange={(e) => setStdData((prevData) => ({ ...prevData, scolarName: e.target.value }))}
                              />
                            </div>
                          </div>
                        )}

                        <div className="d-flex flex-row align-items-center mb-3 col-md-4 col-lg-4 col-xl-3 gender-form">
                          <div className="form-outline flex-fill mb-1 mt-3">
                            <label className="form-label mt-2"> NCC/Scout Guide:</label>
                            <div className="">
                              <label className="form-check-label" style={{ fontWeight: 'normal' }}>
                                <input
                                  type="radio"
                                  name="NCCScout"
                                  value="NCC"
                                  checked={NCCScout === "NCC"}
                                  onChange={handleNCCScoutChange} onFocus={() => handleFocus(71)}
                                  ref={(el) => (inputs.current[71] = el)}
                                  onKeyPress={handleEnterKey}
                                  className="form-check-input me-1"
                                />
                                NCC</label>
                              <label className="form-check-label ms-3" style={{ fontWeight: 'normal' }}>
                                <input
                                  type="radio"
                                  name="NCCScout"
                                  value="ScoutGuide"
                                  checked={NCCScout === "ScoutGuide"} onFocus={() => handleFocus(72)} ref={(el) => (inputs.current[72] = el)}
                                  onChange={handleNCCScoutChange} onKeyPress={handleEnterKey}
                                  className="form-check-input me-1"
                                />
                                Scout Guide
                              </label>
                            </div>
                          </div>
                        </div>

                      </>)}
                    <div onClick={toggleParentsInfo} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showParentsInfo ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Parents Details' : 'पालकांची माहिती'}</span>
                    </div>

                    {showParentsInfo && (
                      <>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Father\'s Occupation' : 'वडिलांचा व्यवसाय'}
                            </label>
                            <input
                              type="text"
                              name="fOccupation"
                              onChange={handleTextChange}
                              value={stdData.fOccupation} onFocus={() => handleFocus(73)} ref={(el) => (inputs.current[73] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Father\'s Education' : 'वडिलांचे शिक्षण'}
                            </label>
                            <input
                              type="text"
                              name="fEducation"
                              onChange={handleTextChange}
                              value={stdData.fEducation} onFocus={() => handleFocus(74)} ref={(el) => (inputs.current[74] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Father\'s Phone Number' : 'वडिलांचा फोन नंबर'}
                            </label>
                            <input
                              type="number"

                              name="fMobile"
                              onChange={handleTextChange}
                              value={stdData.fMobile}
                              className="form-control" onFocus={() => handleFocus(75)} ref={(el) => (inputs.current[75] = el)}
                              maxLength={10}
                            />
                          </div>
                        </div>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Mother\'s Occupation' : 'आईचा व्यवसाय'}
                            </label>
                            <input
                              type="text"
                              name="mOccupation"
                              onChange={handleTextChange}
                              value={stdData.mOccupation} onFocus={() => handleFocus(76)} ref={(el) => (inputs.current[76] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>



                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Mother\'s Education' : 'आईचे  शिक्षण'}
                            </label>
                            <input
                              type="text"
                              name="mEducation"
                              onChange={handleTextChange}
                              value={stdData.mEducation} onFocus={() => handleFocus(77)} ref={(el) => (inputs.current[77] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Mother\'s Phone Number' : 'आईचा फोन नंबर'}
                            </label>
                            <input
                              type="number"
                              name="mMobile"
                              onChange={handleTextChange}
                              value={stdData.mMobile}
                              className="form-control" onFocus={() => handleFocus(78)} ref={(el) => (inputs.current[78] = el)}
                              maxLength={10}
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Annual Family Income' : 'कौटुंबिक वार्षिक उत्पन्न'}
                            </label>
                            <input
                              type="text"
                              name="famIncome"
                              onChange={handleTextChange}
                              value={stdData.famIncome} onFocus={() => handleFocus(79)} ref={(el) => (inputs.current[79] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'No. of children' : 'मुलांची संख्या'}
                            </label>
                            <input
                              type="text"
                              name="totalChildren"
                              onChange={handleTextChange}
                              value={stdData.totalChildren} onFocus={() => handleFocus(80)} ref={(el) => (inputs.current[80] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>


                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Birth Order Of This Student' : 'या विद्यार्थ्याचा जन्म क्रम'}
                            </label>
                            <input
                              type="text"
                              name="birthOrder"
                              onChange={handleTextChange}
                              value={stdData.birthOrder} onFocus={() => handleFocus(81)} ref={(el) => (inputs.current[81] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'One Parent\'s Aadhaar No' : 'एका पालकाचा आधार क्र'}
                            </label>
                            <input
                              type="text"
                              name="pAdhar"
                              onChange={handleTextChange}
                              value={stdData.pAdhar} onFocus={() => handleFocus(82)} ref={(el) => (inputs.current[82] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </>
                    )}


                    <div onClick={toggleBankInfo} style={{ borderBottom: '1px solid #d1caca', padding: '8px', marginBottom: '30px', fontSize: '18px', cursor: 'pointer' }}>
                      <button type="button" className="tog-perdetail " >
                        {showBankInfo ? '▲' : '▼'}
                      </button>
                      <span style={{ color: '#03365e' }}>{language === 'English' ? 'Bank Details' : 'बँकेची माहिती'}</span>
                    </div>
                    {showBankInfo && (
                      <>
                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Account Holder Name' : 'खातेधारकाचे नाव'}
                            </label>
                            <input
                              type="text"
                              name="accHolderName"
                              onChange={handleTextChange}
                              value={stdData.accHolderName} onFocus={() => handleFocus(83)} ref={(el) => (inputs.current[83] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Account No' : 'खाते क्र'}
                            </label>
                            <input
                              type="text"
                              name="accNo"
                              onChange={handleTextChange}
                              value={stdData.accNo} onFocus={() => handleFocus(84)} ref={(el) => (inputs.current[84] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Bank Name' : 'बँकेचे नाव'}
                            </label>
                            <input
                              type="text"
                              name="bankName"
                              onChange={handleTextChange}
                              value={stdData.bankName} onFocus={() => handleFocus(85)} ref={(el) => (inputs.current[85] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'Branch Name' : 'शाखेचे  नाव'}
                            </label>
                            <input
                              type="text"
                              name="branchName"
                              onChange={handleTextChange}
                              value={stdData.branchName} onFocus={() => handleFocus(86)} ref={(el) => (inputs.current[86] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-row align-items-center mb-3 col-md-6 col-lg-4 col-xl-3 ">
                          <div className="form-outline flex-fill mb-0">
                            <label
                              className="form-label"
                              htmlFor="form3Example1c"
                            >
                              {language === 'English' ? 'IFSC Code' : 'IFSC Code'}
                            </label>
                            <input
                              type="text"
                              name="IFSC"
                              onChange={handleTextChange}
                              value={stdData.IFSC} onFocus={() => handleFocus(87)} ref={(el) => (inputs.current[87] = el)}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          <style jsx>{`
            .switch {
              position: relative;
              display: inline-block;
              width: 60px;
              height: 30px;
              margin-top:20px;
              margin-bottom:20px;
            }

            .switch input {
              opacity: 0;
              width: 0;
              height: 0;
            }

            .slider {
              position: absolute;
              cursor: pointer;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #ccc;
              transition: .5s;
              border-radius: 34px;
            }

            .slider:before {
              position: absolute;
              content: "";
              height: 23px;
              width: 24px;
              left: 4px;
              bottom: 4px;
              background-color: white;
              border-radius: 50%;
              transition: .5s;
            }

            input:checked + .slider {
              background-color: #2196F3;
            }

            input:checked + .slider:before {
              transform: translateX(26px);
            }

.active {
  font-weight: bold;
  color: black; 
}

.inactive {
  font-weight: bold;
  color: red; /* Red color for inactive */
}
          `}</style>
          {showReport && selectedStudentData && (
            <div className="overlay">
              <StudentsReport studentData={selectedStudentData} onClose={handleCloseReport} /></div>
          )}
          <div className="col-lg-2 col-xl-2 col-sm-12 pt-md-5 mt-md-5 registerNoExists">
            <div className="text-center mb-4">



              <div className="d-flex align-items-center" style={{ marginTop: '-35px' }}>

                <input
                  type="file"
                  className="form-control stdPhotocss me-2"
                  id="stdPhoto"
                  name="stdPhoto"
                  accept="image/*"
                  onChange={handleLogoChange}
                  onFocus={() => handleFocus(88)}
                  ref={(el) => (inputs.current[88] = el)}
                  style={{ display: 'none' }} // Hide the file input
                />

                {logoURL ? (
                  <div style={{ position: 'relative', margin: 'auto', marginBottom: '-1px' }}>
                    <img
                      src={logoURL}
                      alt="Student's Photo"
                      style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "0px", border: '1px solid black' }} // Optional: make it circular
                    />
                    <FaEdit
                      onClick={() => document.getElementById('stdPhoto').click()} // Trigger file input on click
                      style={{
                        fontSize: '26px',
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                        cursor: 'pointer',
                        color: 'white',
                        backgroundColor: 'rgba(105, 99, 93, 0.6)',
                        borderRadius: '50%',
                        padding: '3px',
                        color: 'white', border: '1px solid black'
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ position: 'relative', margin: 'auto', marginBottom: '-1px' }}>
                    <img
                      src={businessman}
                      alt="Default Student Photo"
                      style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "0px", border: '1px solid black' }}
                    />
                    <FaEdit
                      onClick={() => document.getElementById('stdPhoto').click()} // Trigger file input on click
                      style={{
                        fontSize: '26px',
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                        cursor: 'pointer',
                        color: 'white',
                        backgroundColor: 'rgba(105, 99, 93, 0.6)',
                        borderRadius: '50%',
                        padding: '3px',
                        color: 'white', border: '1px solid black'
                      }}
                    />
                  </div>
                )}

              </div>
              <h6 htmlFor="stdPhoto" className="form-label mt-md-3 ">
                {language === "English" ? "Student's Photo" : "विद्यार्थ्याचा फोटो"}:
              </h6>



              <label className="switch">
                <input
                  type="checkbox"
                  id="activeStatus"
                  checked={isActive}
                  onChange={handleStdStatusChange}
                />
                <span className="slider round"></span>
              </label>
              <span
                style={{ marginLeft: '2px' }}
                className={isActive === true || isActive === undefined ? 'active' : 'inactive'}
              >
                {isActive === true || isActive === undefined ? (language === 'English' ? 'Active' : 'सक्रिय') : (language === 'English' ? 'Inactive' : 'निष्क्रिय')}
              </span>

              <p style={{ color: 'brown', fontSize: '12px', marginTop: '0' }}>
                {isActive === true || isActive === undefined
                  ? (language === 'English' ? 'The student is currently active. Click the switch to inactivate the student.' : 'विद्यार्थी सध्या सक्रिय आहे. विद्यार्थ्याला निष्क्रिय करण्यासाठी स्विचवर क्लिक करा.')
                  : (language === 'English' ? 'The student is currently inactive. Click the switch to activate the student.' : 'विद्यार्थी सध्या निष्क्रिय आहे. विद्यार्थ्याला सक्रिय करण्यासाठी स्विचवर क्लिक करा.')}
              </p>
            </div>
            <hr />

            {(registerNoExists || stdData.serialNo) ? (
              <div>
                <div className="text-center mb-4 ">
                  <button
                    type="button"
                    // className="btn btn-md me-sm-2 col-md-12 m-4 w-50"
                    className={savingData ? 'button-blur btn btn-md' : ' className="btn btn-md me-sm-2 col-md-12 m-4 w-50 "'}
                    style={{ backgroundColor: '#238323' }}
                    onClick={handleUpdate} disabled={savingData}>
                    {language === 'English' ? ' Update' : 'अपडेट करा'}
                  </button>
                  {savingData && <img width={'40px'} className="registerLoading" src={loadingspinner} />}

                  <button
                    type="button"
                    className="btn btn-md me-sm-2 col-md-12 m-4 w-50 "
                    onClick={handleReport} style={{ backgroundColor: '#e3a800' }}
                  >
                    {language === 'English' ? ' Report' : 'अहवाल '}
                  </button>
                  <button
                    type="button"
                    className="btn btn-md me-sm-2 col-md-12 m-4 w-50 " style={{ backgroundColor: 'red' }}
                    onClick={handleDelete}
                  >
                    {language === 'English' ? 'Delete ' : 'डिलीट करा'}
                  </button>
                  <div className="text-center mb-4">
                    <button
                      type="button"
                      className='btn me-sm-2 col-md-12 m-4 w-50 ' style={{
                        background: 'rgb(58 183 187)'
                      }}
                      onClick={handleBackCancelButtonClick}
                    >
                      {serialNumberFromUrl ? "Back" : "Cancel"}
                    </button>
                  </div>

                  <div className="text-center mb-4">

                    <button className="btn btn-primary btn-md" onClick={() => setShowPopup(true)}>
                      {language === 'English' ? 'Upload Document' : 'दस्तऐवज अपलोड करा'}
                    </button>
                    <button className="btn btn-info btn-md" style={{ backgroundColor: '#17a2b8', color: '#fff', marginLeft: '10px' }} onClick={() => setShowPopup(true)}>
                      {language === 'English' ? 'Show Document' : 'दस्तऐवज पहा'}
                    </button>

                    {savingData && <img width={'40px'} className="registerLoading" src={loadingspinner} />}

                    {showPopup && (
                      <div className="popup-overlay" style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backdropFilter: 'blur(5px)',
                        padding: "30px",
                      }}>
                        <div className="popup-content" style={{
                          width: '40%',
                          maxHeight: '80%',
                          overflowY: 'auto',
                          padding: '20px',
                          background: '#fff',
                          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                          borderRadius: '8px',
                          position: 'relative'
                        }}>
                          <h4>Select Document</h4>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                            <select value={documentType} onChange={(e) => setDocumentType(e.target.value)} style={{ width: '42%', height: '40px', padding: '3px' }}>
                              <option value="">select</option>
                              <option value="PAN">PAN</option>
                              <option value="Aadhaar">Aadhaar</option>
                              <option value="Passport">Passport</option>
                              <option value="ID Card">ID Card</option>
                              <option value="License">License</option>
                              <option value="Leaving Certificate">Leaving Certificate</option>
                            </select>

                            <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
                            <button className="btn btn-primary" style={{ width: '28%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '12px' }} onClick={handleUploadClick}><i className="fa-solid fa-file-medical" style={{ fontSize: '16px', marginRight: '8px' }}></i>Select from device</button>
                            <button className="btn btn-info" style={{ width: '14%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '14px', backgroundColor: '#17a2b8', color: '#fff' }} onClick={handleShowDocument}>SHOW</button>
                            <button className="btn btn-success" style={{ width: '14%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '14px', backgroundColor: 'green' }} onClick={handleAddDocument}>ADD</button>

                          </div>

                          <br />

                          {fileName && <p style={{ marginTop: '-20px' }}>File Name: {fileName}</p>}

                          <div style={{ display: 'flex', gap: '15px', marginTop: '10px', justifyContent: "center" }}>

                            <button className="registerNewCloseBtn" style={{ backgroundColor: 'red', borderRadius: '50%', width: '26px' }} onClick={() => setShowPopup(false)}><CloseIcon /></button>


                          </div>
                          {savedDocuments && savedDocuments.length > 0 && (
                            <div>
                              <h5>Uploaded Documents:</h5>
                              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                                <thead>
                                  <tr>
                                    <th style={{ textAlign: "left", padding: "5px" }}>Document</th>
                                    <th style={{ textAlign: "left", padding: "5px" }}>File</th>
                                    <th style={{ textAlign: "left", padding: "5px" }}>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {savedDocuments.map((doc, index) => (
                                    <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                      <td style={{ padding: "5px" }}>{doc.documentType}</td>
                                      <td style={{ padding: "5px" }}>{doc.fileName}</td>
                                      <td style={{ padding: "5px", paddingTop: '20px' }}>
                                        <button style={{ width: '80px', marginRight: '20px', height: '40px' }} className="btn btn-info btn-sm" onClick={() => handleViewDocument(doc.fileURL)}>{language === 'English' ? 'Show' : 'पहा'}</button>
                                        <button style={{ backgroundColor: '#df1f1f', width: '80px', height: '40px' }} className="btn btn-danger btn-sm" onClick={() => handleDeleteDocument(doc)}>Delete</button>

                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {viewFileURL && (
                            <div className="view-popup" style={{
                              position: 'fixed',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              background: '#fff',
                              padding: '20px',
                              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              borderRadius: '8px',
                              zIndex: 1000
                            }}>
                              {viewFileURL && viewFileURL.toLowerCase().includes('.pdf') ? (
                                <iframe src={viewFileURL} title="Document Preview" style={{ width: '600px', height: '500px', maxWidth: '100%', border: 'none' }} />
                              ) : (
                                <img src={viewFileURL} alt="Document Preview" style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                              )}
                              <br />
                              <button className="btn" onClick={() => setViewFileURL("")} style={{ marginTop: '20px', padding: '4px', width: '140px', backgroundColor: '#df1f1f' }}>Close Preview</button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                </div>
              </div>
            ) : (
              <>
                <div className="text-center mb-4">
                  <button
                    type="button"
                    className={savingData ? 'button-blur btn btn-md' : 'btn btn-success btn-md'} style={{ backgroundColor: '#238323' }}
                    onClick={handleRegister}
                    disabled={savingData}
                  >
                    {language === 'English' ? 'Register' : ' रजिस्टर करा'}
                  </button>
                  {savingData && <img width={'40px'} className="registerLoading" src={loadingspinner} />}
                </div>

                {stdData.registerNo && (
                  <div className="text-center mb-4">
                    <button className="btn btn-primary btn-md" onClick={() => setShowPopup(true)}>
                      {language === 'English' ? 'Upload Document' : 'दस्तऐवज अपलोड करा'}
                    </button>
                    <button className="btn btn-info btn-md" style={{ backgroundColor: '#17a2b8', color: '#fff', marginLeft: '10px' }} onClick={() => setShowPopup(true)}>
                      {language === 'English' ? 'Show Document' : 'दस्तऐवज पहा'}
                    </button>

                    {showPopup && (
                      <div className="popup-overlay" style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backdropFilter: 'blur(5px)',
                        padding: "30px",
                      }}>
                        <div className="popup-content" style={{
                          width: '40%',
                          maxHeight: '80%',
                          overflowY: 'auto',
                          padding: '20px',
                          background: '#fff',
                          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                          borderRadius: '8px',
                          position: 'relative'
                        }}>
                          <h4>Select Document</h4>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                            <select value={documentType} onChange={(e) => setDocumentType(e.target.value)} style={{ width: '42%', height: '40px', padding: '3px' }}>
                              <option value="">select</option>
                              <option value="PAN">PAN</option>
                              <option value="Aadhaar">Aadhaar</option>
                              <option value="Passport">Passport</option>
                              <option value="ID Card">ID Card</option>
                              <option value="License">License</option>
                              <option value="Leaving Certificate">Leaving Certificate</option>
                            </select>

                            <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
                            <button className="btn btn-primary" style={{ width: '28%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '12px' }} onClick={handleUploadClick}><i className="fa-solid fa-file-medical" style={{ fontSize: '16px', marginRight: '8px' }}></i>Select from device</button>
                            <button className="btn btn-info" style={{ width: '14%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '14px', backgroundColor: '#17a2b8', color: '#fff' }} onClick={handleShowDocument}>SHOW</button>
                            <button className="btn btn-success" style={{ width: '14%', height: '40px', padding: '3px', marginTop: '22px', fontSize: '14px', backgroundColor: 'green' }} onClick={handleAddDocument}>ADD</button>

                          </div>

                          <br />

                          {fileName && <p style={{ marginTop: '-20px' }}>File Name: {fileName}</p>}

                          <div style={{ display: 'flex', gap: '15px', marginTop: '10px', justifyContent: "center" }}>

                            <button className="registerNewCloseBtn" style={{ backgroundColor: 'red', borderRadius: '50%', width: '26px' }} onClick={() => setShowPopup(false)}><CloseIcon /></button>

                          </div>
                          {savedDocuments && savedDocuments.length > 0 && (
                            <div>
                              <h5>Uploaded Documents</h5>
                              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                                <thead>
                                  <tr>
                                    <th style={{ textAlign: "left", padding: "5px" }}>Document</th>
                                    <th style={{ textAlign: "left", padding: "5px" }}>File</th>
                                    <th style={{ textAlign: "left", padding: "5px" }}>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {savedDocuments.map((doc, index) => (
                                    <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                      <td style={{ padding: "5px" }}>{doc.documentType}</td>
                                      <td style={{ padding: "5px" }}>{doc.fileName}</td>
                                      <td style={{ padding: "5px" }}>
                                        <button style={{ width: '80px', marginRight: '20px', height: '40px' }} className="btn btn-info btn-sm" onClick={() => handleViewDocument(doc.fileURL)}>{language === 'English' ? 'Show' : 'पहा'}</button>
                                        <button style={{ backgroundColor: '#df1f1f', width: '80px', height: '40px' }} className="btn btn-danger btn-sm" onClick={() => handleDeleteDocument(doc)}>{language === 'English' ? 'Delete' : 'डिलीट'}</button>

                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                          {viewFileURL && (
                            <div className="view-popup" style={{
                              position: 'fixed',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              background: '#fff',
                              padding: '20px',
                              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                              borderRadius: '8px',
                              zIndex: 1000,
                              textAlign: 'center' // Center align buttons
                            }}>
                              {viewFileURL && viewFileURL.toLowerCase().includes('.pdf') ? (
                                <iframe src={viewFileURL} title="Document Preview" style={{ width: '600px', height: '500px', maxWidth: '100%', border: 'none' }} />
                              ) : (
                                <img src={viewFileURL} alt="Document Preview" style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                              )}
                              <br />


                              <button className="btn" onClick={() => setViewFileURL("")} style={{ marginTop: '20px', padding: '4px', width: '140px', backgroundColor: '#df1f1f' }}>
                                Close Preview
                              </button>
                            </div>
                          )}

                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="text-center mb-4">
                  <button
                    type="button"
                    className='btn btn-primary btn-md px-3' style={{ width: '133px', backgroundColor: 'rgb(58 183 187)' }}
                    onClick={handleBackCancelButtonClick}
                  >
                    {serialNumberFromUrl ? "Back" : "Cancel"}
                  </button>
                </div>

              </>

            )}


          </div>
        </div>
      </div>

    </div>
  );
}

export default StudentRegister;